<template>
  <div>
    <section
      v-if="property"
      class="property-detail n-section-primary !tw-pb-0 !tw-pt-36"
      :style="{
        backgroundColor: vars.backgroundColor ? `var(--c-${vars.backgroundColor})` : 'var(--c-section_secondary)',
      }"
    >
      <div class="tw-flex tw-w-full tw-flex-col" v-if="variant === variants.v1 || variant === variants.v2">
        <div class="tw-flex tw-justify-between tw-pb-6">
          <library-properties-back-to-all-properties-navbar color="var(--c-secondary)" />
        </div>
        <div class="mt-5 tw-grid tw-grid-cols-12 tw-items-center tw-justify-between">
          <div class="tw-col-span-12 tw-flex tw-flex-col lg:tw-col-span-7">
            <h3>{{ property.advert_heading }}</h3>
            <div class="tw-mt-6 tw-flex tw-items-center tw-gap-1">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10 11.25C9.38193 11.25 8.77775 11.0667 8.26384 10.7233C7.74994 10.38 7.3494 9.89191 7.11288 9.32089C6.87635 8.74987 6.81447 8.12154 6.93505 7.51534C7.05563 6.90915 7.35325 6.35233 7.79029 5.91529C8.22733 5.47825 8.78415 5.18063 9.39034 5.06005C9.99654 4.93947 10.6249 5.00135 11.1959 5.23788C11.7669 5.4744 12.255 5.87494 12.5983 6.38884C12.9417 6.90275 13.125 7.50693 13.125 8.125C13.124 8.9535 12.7945 9.74778 12.2086 10.3336C11.6228 10.9195 10.8285 11.249 10 11.25ZM10 6.25C9.62916 6.25 9.26665 6.35997 8.95831 6.566C8.64997 6.77202 8.40964 7.06486 8.26773 7.40747C8.12581 7.75008 8.08868 8.12708 8.16103 8.4908C8.23338 8.85451 8.41195 9.1886 8.67418 9.45083C8.9364 9.71305 9.27049 9.89163 9.63421 9.96397C9.99792 10.0363 10.3749 9.99919 10.7175 9.85728C11.0601 9.71536 11.353 9.47504 11.559 9.1667C11.765 8.85835 11.875 8.49584 11.875 8.125C11.8745 7.62787 11.6768 7.15125 11.3253 6.79972C10.9738 6.4482 10.4971 6.2505 10 6.25Z"
                  fill="black"
                />
                <path
                  d="M10 18.75L4.72751 12.5319C4.65425 12.4385 4.58174 12.3445 4.51001 12.25C3.60937 11.0636 3.12282 9.61452 3.12501 8.125C3.12501 6.30164 3.84934 4.55295 5.13865 3.26364C6.42796 1.97433 8.17664 1.25 10 1.25C11.8234 1.25 13.5721 1.97433 14.8614 3.26364C16.1507 4.55295 16.875 6.30164 16.875 8.125C16.8772 9.61384 16.3909 11.0623 15.4906 12.2481L15.49 12.25C15.49 12.25 15.3025 12.4963 15.2744 12.5294L10 18.75ZM5.50813 11.4969C5.50813 11.4969 5.65376 11.6894 5.68688 11.7306L10 16.8175L14.3188 11.7237C14.3463 11.6894 14.4925 11.4956 14.4931 11.495C15.2289 10.5257 15.6265 9.34189 15.625 8.125C15.625 6.63316 15.0324 5.20242 13.9775 4.14752C12.9226 3.09263 11.4918 2.5 10 2.5C8.50816 2.5 7.07742 3.09263 6.02253 4.14752C4.96764 5.20242 4.37501 6.63316 4.37501 8.125C4.3737 9.34265 4.77174 10.5271 5.50813 11.4969Z"
                  fill="black"
                />
              </svg>
              <p class="tw-capitalize">{{ property.display_address }}</p>
            </div>
            <div class="tw-mt-6 tw-flex tw-items-center tw-gap-1">
              <div v-if="!property.is_locked" class="tw-flex tw-flex-row tw-items-center tw-gap-4">
                <p>Beds: {{ property.bedroom }}</p>
                <p>Baths: {{ property.bathroom }}</p>
                <p>Receptions: {{ property.reception }}</p>
              </div>
            </div>
            <div class="tw-flex tw-items-center tw-gap-5 tw-py-5" v-if="variant === variants.v2 && !property.is_locked">
              <button
                @click="onSendLead()"
                class="n-primary tw-flex tw-max-w-72 tw-items-center tw-justify-center tw-gap-4"
              >
                Book a viewing
              </button>
            </div>
          </div>
          <div
            class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between lg:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8"
          >
            <div
              class="tw-flex tw-w-full tw-items-center tw-justify-between max-lg:tw-pt-4 lg:tw-justify-end lg:tw-gap-8"
            >
              <div v-if="property.price">
                <p v-if="property.price.type.name">
                  {{ property.price.type.name }}
                </p>
                <h5 class="!tw-text-3xl">{{ property.price.price }}</h5>
              </div>

              <div
                class="tw-flex tw-h-12 tw-w-12 tw-cursor-pointer tw-items-center tw-justify-center"
                style="background-color: var(--c-secondary); border-radius: var(--rounded)"
                @click="onShared()"
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M15 18.3333C14.3056 18.3333 13.7153 18.0903 13.2292 17.6042C12.7431 17.118 12.5 16.5278 12.5 15.8333C12.5 15.7361 12.5069 15.6353 12.5208 15.5308C12.5347 15.4264 12.5556 15.3328 12.5833 15.25L6.70833 11.8333C6.47222 12.0417 6.20833 12.205 5.91667 12.3233C5.625 12.4417 5.31944 12.5005 5 12.5C4.30556 12.5 3.71528 12.2569 3.22917 11.7708C2.74306 11.2847 2.5 10.6944 2.5 9.99999C2.5 9.30555 2.74306 8.71527 3.22917 8.22916C3.71528 7.74305 4.30556 7.49999 5 7.49999C5.31944 7.49999 5.625 7.55916 5.91667 7.67749C6.20833 7.79582 6.47222 7.95888 6.70833 8.16666L12.5833 4.74999C12.5556 4.66666 12.5347 4.57305 12.5208 4.46916C12.5069 4.36527 12.5 4.26443 12.5 4.16666C12.5 3.47221 12.7431 2.88193 13.2292 2.39582C13.7153 1.90971 14.3056 1.66666 15 1.66666C15.6944 1.66666 16.2847 1.90971 16.7708 2.39582C17.2569 2.88193 17.5 3.47221 17.5 4.16666C17.5 4.8611 17.2569 5.45138 16.7708 5.93749C16.2847 6.4236 15.6944 6.66666 15 6.66666C14.6806 6.66666 14.375 6.60777 14.0833 6.48999C13.7917 6.37221 13.5278 6.20888 13.2917 5.99999L7.41667 9.41666C7.44444 9.49999 7.46528 9.59388 7.47917 9.69832C7.49306 9.80277 7.5 9.90332 7.5 9.99999C7.5 10.0972 7.49306 10.198 7.47917 10.3025C7.46528 10.4069 7.44444 10.5005 7.41667 10.5833L13.2917 14C13.5278 13.7917 13.7917 13.6286 14.0833 13.5108C14.375 13.393 14.6806 13.3339 15 13.3333C15.6944 13.3333 16.2847 13.5764 16.7708 14.0625C17.2569 14.5486 17.5 15.1389 17.5 15.8333C17.5 16.5278 17.2569 17.118 16.7708 17.6042C16.2847 18.0903 15.6944 18.3333 15 18.3333Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
            <div v-if="!property.is_locked" class="tw-pt-6">
              <button class="n-primary" @click="onSendLead()" v-if="variant !== variants.v2">ARRANGE A VIEWING</button>
            </div>
          </div>
        </div>
      </div>

      <div class="tw-flex tw-w-full tw-flex-col" v-else-if="variant === variants.v3">
        <div class="tw-flex tw-justify-between tw-pb-6">
          <library-properties-back-to-all-properties-navbar color="var(--c-primary)" />
        </div>
        <div class="mt-5 tw-grid tw-grid-cols-12 tw-items-center tw-justify-between">
          <div class="tw-col-span-12 tw-flex tw-flex-col lg:tw-col-span-7">
            <h2>{{ property.advert_heading }}</h2>
            <div class="tw-mt-6 tw-flex tw-items-center tw-gap-1">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="var(--c-primary)"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 11.25C9.38193 11.25 8.77775 11.0667 8.26384 10.7233C7.74994 10.38 7.3494 9.89191 7.11288 9.32089C6.87635 8.74987 6.81447 8.12154 6.93505 7.51534C7.05563 6.90915 7.35325 6.35233 7.79029 5.91529C8.22733 5.47825 8.78415 5.18063 9.39034 5.06005C9.99654 4.93947 10.6249 5.00135 11.1959 5.23788C11.7669 5.4744 12.255 5.87494 12.5983 6.38884C12.9417 6.90275 13.125 7.50693 13.125 8.125C13.124 8.9535 12.7945 9.74778 12.2086 10.3336C11.6228 10.9195 10.8285 11.249 10 11.25ZM10 6.25C9.62916 6.25 9.26665 6.35997 8.95831 6.566C8.64997 6.77202 8.40964 7.06486 8.26773 7.40747C8.12581 7.75008 8.08868 8.12708 8.16103 8.4908C8.23338 8.85451 8.41195 9.1886 8.67418 9.45083C8.9364 9.71305 9.27049 9.89163 9.63421 9.96397C9.99792 10.0363 10.3749 9.99919 10.7175 9.85728C11.0601 9.71536 11.353 9.47504 11.559 9.1667C11.765 8.85835 11.875 8.49584 11.875 8.125C11.8745 7.62787 11.6768 7.15125 11.3253 6.79972C10.9738 6.4482 10.4971 6.2505 10 6.25Z"
                  fill="var(--c-primary)"
                />
                <path
                  d="M10 18.75L4.72751 12.5319C4.65425 12.4385 4.58174 12.3445 4.51001 12.25C3.60937 11.0636 3.12282 9.61452 3.12501 8.125C3.12501 6.30164 3.84934 4.55295 5.13865 3.26364C6.42796 1.97433 8.17664 1.25 10 1.25C11.8234 1.25 13.5721 1.97433 14.8614 3.26364C16.1507 4.55295 16.875 6.30164 16.875 8.125C16.8772 9.61384 16.3909 11.0623 15.4906 12.2481L15.49 12.25C15.49 12.25 15.3025 12.4963 15.2744 12.5294L10 18.75ZM5.50813 11.4969C5.50813 11.4969 5.65376 11.6894 5.68688 11.7306L10 16.8175L14.3188 11.7237C14.3463 11.6894 14.4925 11.4956 14.4931 11.495C15.2289 10.5257 15.6265 9.34189 15.625 8.125C15.625 6.63316 15.0324 5.20242 13.9775 4.14752C12.9226 3.09263 11.4918 2.5 10 2.5C8.50816 2.5 7.07742 3.09263 6.02253 4.14752C4.96764 5.20242 4.37501 6.63316 4.37501 8.125C4.3737 9.34265 4.77174 10.5271 5.50813 11.4969Z"
                  fill="var(--c-primary)"
                />
              </svg>
              <p class="tw-capitalize">{{ property.display_address }}</p>
            </div>
            <div class="tw-mt-6 tw-flex tw-items-center tw-gap-1">
              <div v-if="!property.is_locked" class="tw-flex tw-flex-row tw-items-center tw-gap-6">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.75 13.5V8.5C0.75 8.05 0.841667 7.64167 1.025 7.275C1.20833 6.90833 1.45 6.58333 1.75 6.3V3.5C1.75 2.66667 2.04167 1.95833 2.625 1.375C3.20833 0.791667 3.91667 0.5 4.75 0.5H8.75C9.13333 0.5 9.49167 0.571 9.825 0.713C10.1583 0.855 10.4667 1.05067 10.75 1.3C11.0333 1.05 11.3417 0.854333 11.675 0.713C12.0083 0.571666 12.3667 0.500667 12.75 0.5H16.75C17.5833 0.5 18.2917 0.791667 18.875 1.375C19.4583 1.95833 19.75 2.66667 19.75 3.5V6.3C20.05 6.58333 20.2917 6.90833 20.475 7.275C20.6583 7.64167 20.75 8.05 20.75 8.5V13.5C20.75 13.7833 20.654 14.021 20.462 14.213C20.27 14.405 20.0327 14.5007 19.75 14.5C19.4673 14.4993 19.23 14.4033 19.038 14.212C18.846 14.0207 18.75 13.7833 18.75 13.5V12.5H2.75V13.5C2.75 13.7833 2.654 14.021 2.462 14.213C2.27 14.405 2.03267 14.5007 1.75 14.5C1.46733 14.4993 1.23 14.4033 1.038 14.212C0.846 14.0207 0.75 13.7833 0.75 13.5ZM11.75 5.5H17.75V3.5C17.75 3.21667 17.654 2.97933 17.462 2.788C17.27 2.59667 17.0327 2.50067 16.75 2.5H12.75C12.4667 2.5 12.2293 2.596 12.038 2.788C11.8467 2.98 11.7507 3.21733 11.75 3.5V5.5ZM3.75 5.5H9.75V3.5C9.75 3.21667 9.654 2.97933 9.462 2.788C9.27 2.59667 9.03267 2.50067 8.75 2.5H4.75C4.46667 2.5 4.22933 2.596 4.038 2.788C3.84667 2.98 3.75067 3.21733 3.75 3.5V5.5Z"
                      fill="#EC5D23"
                    />
                  </svg>
                  <span>{{ property.bedroom }}</span>
                </div>

                <div class="tw-flex tw-items-center tw-gap-2">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1.9375 14.7501C1.93852 15.2487 2.04483 15.7414 2.24947 16.196C2.45411 16.6506 2.75247 17.0569 3.125 17.3882V18.9063C3.125 19.0638 3.18756 19.2148 3.29891 19.3262C3.41026 19.4375 3.56128 19.5001 3.71875 19.5001H4.90625C5.06372 19.5001 5.21475 19.4375 5.32609 19.3262C5.43744 19.2148 5.5 19.0638 5.5 18.9063V18.3126H15V18.9063C15 19.0638 15.0626 19.2148 15.1739 19.3262C15.2853 19.4375 15.4363 19.5001 15.5938 19.5001H16.7812C16.9387 19.5001 17.0897 19.4375 17.2011 19.3262C17.3124 19.2148 17.375 19.0638 17.375 18.9063V17.3882C17.7475 17.0569 18.0459 16.6506 18.2505 16.196C18.4552 15.7414 18.5615 15.2487 18.5625 14.7501V12.9689H1.9375V14.7501ZM19.1562 10.0002H3.71875V3.07007C3.71909 2.91424 3.76557 2.76199 3.85233 2.63255C3.93909 2.5031 4.06224 2.40224 4.20625 2.3427C4.35026 2.28316 4.50868 2.2676 4.66153 2.29799C4.81437 2.32837 4.95479 2.40334 5.06508 2.51344L5.78018 3.22815C5.29293 4.33697 5.49777 5.42166 6.10006 6.18685L6.09375 6.19316C5.98282 6.30445 5.92054 6.45517 5.92054 6.6123C5.92054 6.76944 5.98282 6.92016 6.09375 7.03145L6.51346 7.45115C6.56859 7.5063 6.63405 7.55005 6.7061 7.5799C6.77815 7.60974 6.85537 7.6251 6.93335 7.6251C7.01133 7.6251 7.08855 7.60974 7.1606 7.5799C7.23265 7.55005 7.29811 7.5063 7.35324 7.45115L11.2635 3.54098C11.3186 3.48585 11.3624 3.42039 11.3922 3.34834C11.422 3.2763 11.4374 3.19908 11.4374 3.12109C11.4374 3.04311 11.422 2.96589 11.3922 2.89385C11.3624 2.8218 11.3186 2.75634 11.2635 2.70121L10.8438 2.2815C10.7324 2.17024 10.5814 2.10774 10.424 2.10774C10.2666 2.10774 10.1157 2.17024 10.0043 2.2815L9.99803 2.28781C9.23283 1.68553 8.14887 1.48069 7.0393 1.96793L6.32457 1.25284C5.96517 0.893409 5.50726 0.648625 5.00873 0.549452C4.51021 0.450278 3.99347 0.501169 3.52387 0.695688C3.05427 0.890207 2.6529 1.21962 2.37053 1.64226C2.08815 2.0649 1.93746 2.56178 1.9375 3.07007V10.0002H1.34375C1.18628 10.0002 1.03526 10.0627 0.923905 10.1741C0.812556 10.2854 0.75 10.4364 0.75 10.5939L0.75 11.1877C0.75 11.3451 0.812556 11.4961 0.923905 11.6075C1.03526 11.7188 1.18628 11.7814 1.34375 11.7814H19.1562C19.3137 11.7814 19.4647 11.7188 19.5761 11.6075C19.6874 11.4961 19.75 11.3451 19.75 11.1877V10.5939C19.75 10.4364 19.6874 10.2854 19.5761 10.1741C19.4647 10.0627 19.3137 10.0002 19.1562 10.0002Z"
                      fill="#EC5D23"
                    />
                  </svg>

                  <span>{{ property.bathroom }}</span>
                </div>

                <div class="tw-flex tw-items-center tw-gap-2">
                  <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M13.4773 0.5H8.02273C6.73045 0.499879 5.4801 0.948382 4.49448 1.76559C3.50885 2.5828 2.85198 3.71563 2.64091 4.96222C2.76636 4.95037 2.89364 4.94444 3.02273 4.94444C4.1077 4.94444 5.14824 5.36587 5.91544 6.11602C6.68263 6.86616 7.11364 7.88358 7.11364 8.94444V10.2778H14.3864V8.94444C14.3864 8.38771 14.5053 7.83711 14.7355 7.32788C14.9656 6.81866 15.302 6.36201 15.723 5.98718C16.144 5.61234 16.6404 5.32757 17.1804 5.15108C17.7204 4.97458 18.2922 4.91026 18.8591 4.96222C18.648 3.71563 17.9911 2.5828 17.0055 1.76559C16.0199 0.948382 14.7696 0.499879 13.4773 0.5ZM18.9318 6.76667C18.6016 6.70075 18.2605 6.70749 17.9332 6.78638C17.606 6.86527 17.3008 7.01435 17.0397 7.22281C16.7786 7.43127 16.5683 7.69389 16.4238 7.99166C16.2794 8.28943 16.2045 8.61488 16.2045 8.94444V12.9444H14.3864V12.0556H7.11364V12.9444H5.29545V8.94444C5.29545 8.35507 5.05601 7.78984 4.62979 7.3731C4.20357 6.95635 3.62549 6.72222 3.02273 6.72222C2.41996 6.72222 1.84189 6.95635 1.41567 7.3731C0.989447 7.78984 0.75 8.35507 0.75 8.94444C0.75 9.468 0.915455 9.868 1.10455 10.3267C1.35909 10.9453 1.65909 11.6689 1.65909 12.9444V15.6111C1.65909 15.8469 1.75487 16.073 1.92536 16.2397C2.09585 16.4064 2.32708 16.5 2.56818 16.5H18.9318C19.1729 16.5 19.4042 16.4064 19.5746 16.2397C19.7451 16.073 19.8409 15.8469 19.8409 15.6111V12.9444C19.8409 11.6698 20.1409 10.9444 20.3955 10.3267C20.5845 9.868 20.75 9.468 20.75 8.94444C20.7501 8.43215 20.5692 7.93556 20.2379 7.53871C19.9065 7.14186 19.4452 6.86912 18.9318 6.76667Z"
                      fill="#EC5D23"
                    />
                  </svg>

                  <span>{{ property.reception }}</span>
                </div>
              </div>
            </div>
            <div class="tw-flex tw-items-center tw-gap-5 tw-py-5" v-if="variant === variants.v2 && !property.is_locked">
              <button
                @click="onSendLead()"
                class="n-primary tw-flex tw-max-w-72 tw-items-center tw-justify-center tw-gap-4"
              >
                Book a viewing
              </button>
            </div>
          </div>
          <div
            class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between lg:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8"
          >
            <div
              class="tw-flex tw-w-full tw-items-center tw-justify-between max-lg:tw-pt-4 lg:tw-justify-end lg:tw-gap-8"
            >
              <div v-if="property.price">
                <p v-if="property.price.type.name">
                  {{ property.price.type.name }}
                </p>
                <h2 class="!tw-text-3xl" style="color: var(--c-primary)">{{ property.price.price }}</h2>
              </div>

              <div
                class="tw-flex tw-h-12 tw-w-12 tw-cursor-pointer tw-items-center tw-justify-center"
                style="background-color: var(--c-primary); border-radius: var(--rounded)"
                @click="onShared()"
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M15 18.3333C14.3056 18.3333 13.7153 18.0903 13.2292 17.6042C12.7431 17.118 12.5 16.5278 12.5 15.8333C12.5 15.7361 12.5069 15.6353 12.5208 15.5308C12.5347 15.4264 12.5556 15.3328 12.5833 15.25L6.70833 11.8333C6.47222 12.0417 6.20833 12.205 5.91667 12.3233C5.625 12.4417 5.31944 12.5005 5 12.5C4.30556 12.5 3.71528 12.2569 3.22917 11.7708C2.74306 11.2847 2.5 10.6944 2.5 9.99999C2.5 9.30555 2.74306 8.71527 3.22917 8.22916C3.71528 7.74305 4.30556 7.49999 5 7.49999C5.31944 7.49999 5.625 7.55916 5.91667 7.67749C6.20833 7.79582 6.47222 7.95888 6.70833 8.16666L12.5833 4.74999C12.5556 4.66666 12.5347 4.57305 12.5208 4.46916C12.5069 4.36527 12.5 4.26443 12.5 4.16666C12.5 3.47221 12.7431 2.88193 13.2292 2.39582C13.7153 1.90971 14.3056 1.66666 15 1.66666C15.6944 1.66666 16.2847 1.90971 16.7708 2.39582C17.2569 2.88193 17.5 3.47221 17.5 4.16666C17.5 4.8611 17.2569 5.45138 16.7708 5.93749C16.2847 6.4236 15.6944 6.66666 15 6.66666C14.6806 6.66666 14.375 6.60777 14.0833 6.48999C13.7917 6.37221 13.5278 6.20888 13.2917 5.99999L7.41667 9.41666C7.44444 9.49999 7.46528 9.59388 7.47917 9.69832C7.49306 9.80277 7.5 9.90332 7.5 9.99999C7.5 10.0972 7.49306 10.198 7.47917 10.3025C7.46528 10.4069 7.44444 10.5005 7.41667 10.5833L13.2917 14C13.5278 13.7917 13.7917 13.6286 14.0833 13.5108C14.375 13.393 14.6806 13.3339 15 13.3333C15.6944 13.3333 16.2847 13.5764 16.7708 14.0625C17.2569 14.5486 17.5 15.1389 17.5 15.8333C17.5 16.5278 17.2569 17.118 16.7708 17.6042C16.2847 18.0903 15.6944 18.3333 15 18.3333Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
            <div v-if="!property.is_locked" class="tw-pt-6">
              <button class="n-primary" @click="onSendLead()" v-if="variant !== variants.v2">ARRANGE A VIEWING</button>
            </div>
          </div>
        </div>
      </div>

      <div class="tw-flex tw-w-full tw-flex-col" v-else-if="variant === variants.v4">
        <div class="tw-flex tw-justify-between tw-pb-6">
          <library-properties-back-to-all-properties-navbar color="var(--c-primary)" />
        </div>
        <div class="mt-5 tw-grid tw-grid-cols-12 tw-items-center tw-justify-between">
          <div class="tw-col-span-12 tw-flex tw-flex-col lg:tw-col-span-7">
            <h2>{{ property.advert_heading }}</h2>
            <div class="tw-mt-6 tw-flex tw-items-center tw-gap-1">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="var(--c-primary)"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 11.25C9.38193 11.25 8.77775 11.0667 8.26384 10.7233C7.74994 10.38 7.3494 9.89191 7.11288 9.32089C6.87635 8.74987 6.81447 8.12154 6.93505 7.51534C7.05563 6.90915 7.35325 6.35233 7.79029 5.91529C8.22733 5.47825 8.78415 5.18063 9.39034 5.06005C9.99654 4.93947 10.6249 5.00135 11.1959 5.23788C11.7669 5.4744 12.255 5.87494 12.5983 6.38884C12.9417 6.90275 13.125 7.50693 13.125 8.125C13.124 8.9535 12.7945 9.74778 12.2086 10.3336C11.6228 10.9195 10.8285 11.249 10 11.25ZM10 6.25C9.62916 6.25 9.26665 6.35997 8.95831 6.566C8.64997 6.77202 8.40964 7.06486 8.26773 7.40747C8.12581 7.75008 8.08868 8.12708 8.16103 8.4908C8.23338 8.85451 8.41195 9.1886 8.67418 9.45083C8.9364 9.71305 9.27049 9.89163 9.63421 9.96397C9.99792 10.0363 10.3749 9.99919 10.7175 9.85728C11.0601 9.71536 11.353 9.47504 11.559 9.1667C11.765 8.85835 11.875 8.49584 11.875 8.125C11.8745 7.62787 11.6768 7.15125 11.3253 6.79972C10.9738 6.4482 10.4971 6.2505 10 6.25Z"
                  fill="var(--c-primary)"
                />
                <path
                  d="M10 18.75L4.72751 12.5319C4.65425 12.4385 4.58174 12.3445 4.51001 12.25C3.60937 11.0636 3.12282 9.61452 3.12501 8.125C3.12501 6.30164 3.84934 4.55295 5.13865 3.26364C6.42796 1.97433 8.17664 1.25 10 1.25C11.8234 1.25 13.5721 1.97433 14.8614 3.26364C16.1507 4.55295 16.875 6.30164 16.875 8.125C16.8772 9.61384 16.3909 11.0623 15.4906 12.2481L15.49 12.25C15.49 12.25 15.3025 12.4963 15.2744 12.5294L10 18.75ZM5.50813 11.4969C5.50813 11.4969 5.65376 11.6894 5.68688 11.7306L10 16.8175L14.3188 11.7237C14.3463 11.6894 14.4925 11.4956 14.4931 11.495C15.2289 10.5257 15.6265 9.34189 15.625 8.125C15.625 6.63316 15.0324 5.20242 13.9775 4.14752C12.9226 3.09263 11.4918 2.5 10 2.5C8.50816 2.5 7.07742 3.09263 6.02253 4.14752C4.96764 5.20242 4.37501 6.63316 4.37501 8.125C4.3737 9.34265 4.77174 10.5271 5.50813 11.4969Z"
                  fill="var(--c-primary)"
                />
              </svg>
              <p class="tw-capitalize">{{ property.display_address }}</p>
            </div>
            <div class="tw-mt-6 tw-flex tw-items-center tw-gap-1">
              <div v-if="!property.is_locked" class="tw-flex tw-flex-row tw-items-center tw-gap-6">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.75 13.5V8.5C0.75 8.05 0.841667 7.64167 1.025 7.275C1.20833 6.90833 1.45 6.58333 1.75 6.3V3.5C1.75 2.66667 2.04167 1.95833 2.625 1.375C3.20833 0.791667 3.91667 0.5 4.75 0.5H8.75C9.13333 0.5 9.49167 0.571 9.825 0.713C10.1583 0.855 10.4667 1.05067 10.75 1.3C11.0333 1.05 11.3417 0.854333 11.675 0.713C12.0083 0.571666 12.3667 0.500667 12.75 0.5H16.75C17.5833 0.5 18.2917 0.791667 18.875 1.375C19.4583 1.95833 19.75 2.66667 19.75 3.5V6.3C20.05 6.58333 20.2917 6.90833 20.475 7.275C20.6583 7.64167 20.75 8.05 20.75 8.5V13.5C20.75 13.7833 20.654 14.021 20.462 14.213C20.27 14.405 20.0327 14.5007 19.75 14.5C19.4673 14.4993 19.23 14.4033 19.038 14.212C18.846 14.0207 18.75 13.7833 18.75 13.5V12.5H2.75V13.5C2.75 13.7833 2.654 14.021 2.462 14.213C2.27 14.405 2.03267 14.5007 1.75 14.5C1.46733 14.4993 1.23 14.4033 1.038 14.212C0.846 14.0207 0.75 13.7833 0.75 13.5ZM11.75 5.5H17.75V3.5C17.75 3.21667 17.654 2.97933 17.462 2.788C17.27 2.59667 17.0327 2.50067 16.75 2.5H12.75C12.4667 2.5 12.2293 2.596 12.038 2.788C11.8467 2.98 11.7507 3.21733 11.75 3.5V5.5ZM3.75 5.5H9.75V3.5C9.75 3.21667 9.654 2.97933 9.462 2.788C9.27 2.59667 9.03267 2.50067 8.75 2.5H4.75C4.46667 2.5 4.22933 2.596 4.038 2.788C3.84667 2.98 3.75067 3.21733 3.75 3.5V5.5Z"
                      fill="var(--c-primary)"
                    />
                  </svg>
                  <span>{{ property.bedroom }}</span>
                </div>

                <div class="tw-flex tw-items-center tw-gap-2">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1.9375 14.7501C1.93852 15.2487 2.04483 15.7414 2.24947 16.196C2.45411 16.6506 2.75247 17.0569 3.125 17.3882V18.9063C3.125 19.0638 3.18756 19.2148 3.29891 19.3262C3.41026 19.4375 3.56128 19.5001 3.71875 19.5001H4.90625C5.06372 19.5001 5.21475 19.4375 5.32609 19.3262C5.43744 19.2148 5.5 19.0638 5.5 18.9063V18.3126H15V18.9063C15 19.0638 15.0626 19.2148 15.1739 19.3262C15.2853 19.4375 15.4363 19.5001 15.5938 19.5001H16.7812C16.9387 19.5001 17.0897 19.4375 17.2011 19.3262C17.3124 19.2148 17.375 19.0638 17.375 18.9063V17.3882C17.7475 17.0569 18.0459 16.6506 18.2505 16.196C18.4552 15.7414 18.5615 15.2487 18.5625 14.7501V12.9689H1.9375V14.7501ZM19.1562 10.0002H3.71875V3.07007C3.71909 2.91424 3.76557 2.76199 3.85233 2.63255C3.93909 2.5031 4.06224 2.40224 4.20625 2.3427C4.35026 2.28316 4.50868 2.2676 4.66153 2.29799C4.81437 2.32837 4.95479 2.40334 5.06508 2.51344L5.78018 3.22815C5.29293 4.33697 5.49777 5.42166 6.10006 6.18685L6.09375 6.19316C5.98282 6.30445 5.92054 6.45517 5.92054 6.6123C5.92054 6.76944 5.98282 6.92016 6.09375 7.03145L6.51346 7.45115C6.56859 7.5063 6.63405 7.55005 6.7061 7.5799C6.77815 7.60974 6.85537 7.6251 6.93335 7.6251C7.01133 7.6251 7.08855 7.60974 7.1606 7.5799C7.23265 7.55005 7.29811 7.5063 7.35324 7.45115L11.2635 3.54098C11.3186 3.48585 11.3624 3.42039 11.3922 3.34834C11.422 3.2763 11.4374 3.19908 11.4374 3.12109C11.4374 3.04311 11.422 2.96589 11.3922 2.89385C11.3624 2.8218 11.3186 2.75634 11.2635 2.70121L10.8438 2.2815C10.7324 2.17024 10.5814 2.10774 10.424 2.10774C10.2666 2.10774 10.1157 2.17024 10.0043 2.2815L9.99803 2.28781C9.23283 1.68553 8.14887 1.48069 7.0393 1.96793L6.32457 1.25284C5.96517 0.893409 5.50726 0.648625 5.00873 0.549452C4.51021 0.450278 3.99347 0.501169 3.52387 0.695688C3.05427 0.890207 2.6529 1.21962 2.37053 1.64226C2.08815 2.0649 1.93746 2.56178 1.9375 3.07007V10.0002H1.34375C1.18628 10.0002 1.03526 10.0627 0.923905 10.1741C0.812556 10.2854 0.75 10.4364 0.75 10.5939L0.75 11.1877C0.75 11.3451 0.812556 11.4961 0.923905 11.6075C1.03526 11.7188 1.18628 11.7814 1.34375 11.7814H19.1562C19.3137 11.7814 19.4647 11.7188 19.5761 11.6075C19.6874 11.4961 19.75 11.3451 19.75 11.1877V10.5939C19.75 10.4364 19.6874 10.2854 19.5761 10.1741C19.4647 10.0627 19.3137 10.0002 19.1562 10.0002Z"
                      fill="var(--c-primary)"
                    />
                  </svg>

                  <span>{{ property.bathroom }}</span>
                </div>

                <div class="tw-flex tw-items-center tw-gap-2">
                  <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M13.4773 0.5H8.02273C6.73045 0.499879 5.4801 0.948382 4.49448 1.76559C3.50885 2.5828 2.85198 3.71563 2.64091 4.96222C2.76636 4.95037 2.89364 4.94444 3.02273 4.94444C4.1077 4.94444 5.14824 5.36587 5.91544 6.11602C6.68263 6.86616 7.11364 7.88358 7.11364 8.94444V10.2778H14.3864V8.94444C14.3864 8.38771 14.5053 7.83711 14.7355 7.32788C14.9656 6.81866 15.302 6.36201 15.723 5.98718C16.144 5.61234 16.6404 5.32757 17.1804 5.15108C17.7204 4.97458 18.2922 4.91026 18.8591 4.96222C18.648 3.71563 17.9911 2.5828 17.0055 1.76559C16.0199 0.948382 14.7696 0.499879 13.4773 0.5ZM18.9318 6.76667C18.6016 6.70075 18.2605 6.70749 17.9332 6.78638C17.606 6.86527 17.3008 7.01435 17.0397 7.22281C16.7786 7.43127 16.5683 7.69389 16.4238 7.99166C16.2794 8.28943 16.2045 8.61488 16.2045 8.94444V12.9444H14.3864V12.0556H7.11364V12.9444H5.29545V8.94444C5.29545 8.35507 5.05601 7.78984 4.62979 7.3731C4.20357 6.95635 3.62549 6.72222 3.02273 6.72222C2.41996 6.72222 1.84189 6.95635 1.41567 7.3731C0.989447 7.78984 0.75 8.35507 0.75 8.94444C0.75 9.468 0.915455 9.868 1.10455 10.3267C1.35909 10.9453 1.65909 11.6689 1.65909 12.9444V15.6111C1.65909 15.8469 1.75487 16.073 1.92536 16.2397C2.09585 16.4064 2.32708 16.5 2.56818 16.5H18.9318C19.1729 16.5 19.4042 16.4064 19.5746 16.2397C19.7451 16.073 19.8409 15.8469 19.8409 15.6111V12.9444C19.8409 11.6698 20.1409 10.9444 20.3955 10.3267C20.5845 9.868 20.75 9.468 20.75 8.94444C20.7501 8.43215 20.5692 7.93556 20.2379 7.53871C19.9065 7.14186 19.4452 6.86912 18.9318 6.76667Z"
                      fill="var(--c-primary)"
                    />
                  </svg>

                  <span>{{ property.reception }}</span>
                </div>
              </div>
            </div>
            <div class="tw-flex tw-items-center tw-gap-5 tw-py-5" v-if="variant === variants.v4 && !property.is_locked">
              <button
                @click="onSendLead()"
                class="n-primary tw-flex tw-max-w-72 tw-items-center tw-justify-center tw-gap-4"
              >
                Book a viewing
              </button>
            </div>
          </div>
          <div
            class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between lg:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8"
          >
            <div
              class="tw-flex tw-w-full tw-items-center tw-justify-between max-lg:tw-pt-4 lg:tw-justify-end lg:tw-gap-8"
            >
              <div v-if="property.price">
                <p v-if="property.price.type.name">
                  {{ property.price.type.name }}
                </p>
                <h2 class="!tw-text-3xl" style="color: var(--c-primary)">{{ property.price.price }}</h2>
              </div>

              <div
                class="tw-flex tw-h-12 tw-w-12 tw-cursor-pointer tw-items-center tw-justify-center"
                style="background-color: var(--c-primary); border-radius: var(--rounded)"
                @click="onShared()"
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M15 18.3333C14.3056 18.3333 13.7153 18.0903 13.2292 17.6042C12.7431 17.118 12.5 16.5278 12.5 15.8333C12.5 15.7361 12.5069 15.6353 12.5208 15.5308C12.5347 15.4264 12.5556 15.3328 12.5833 15.25L6.70833 11.8333C6.47222 12.0417 6.20833 12.205 5.91667 12.3233C5.625 12.4417 5.31944 12.5005 5 12.5C4.30556 12.5 3.71528 12.2569 3.22917 11.7708C2.74306 11.2847 2.5 10.6944 2.5 9.99999C2.5 9.30555 2.74306 8.71527 3.22917 8.22916C3.71528 7.74305 4.30556 7.49999 5 7.49999C5.31944 7.49999 5.625 7.55916 5.91667 7.67749C6.20833 7.79582 6.47222 7.95888 6.70833 8.16666L12.5833 4.74999C12.5556 4.66666 12.5347 4.57305 12.5208 4.46916C12.5069 4.36527 12.5 4.26443 12.5 4.16666C12.5 3.47221 12.7431 2.88193 13.2292 2.39582C13.7153 1.90971 14.3056 1.66666 15 1.66666C15.6944 1.66666 16.2847 1.90971 16.7708 2.39582C17.2569 2.88193 17.5 3.47221 17.5 4.16666C17.5 4.8611 17.2569 5.45138 16.7708 5.93749C16.2847 6.4236 15.6944 6.66666 15 6.66666C14.6806 6.66666 14.375 6.60777 14.0833 6.48999C13.7917 6.37221 13.5278 6.20888 13.2917 5.99999L7.41667 9.41666C7.44444 9.49999 7.46528 9.59388 7.47917 9.69832C7.49306 9.80277 7.5 9.90332 7.5 9.99999C7.5 10.0972 7.49306 10.198 7.47917 10.3025C7.46528 10.4069 7.44444 10.5005 7.41667 10.5833L13.2917 14C13.5278 13.7917 13.7917 13.6286 14.0833 13.5108C14.375 13.393 14.6806 13.3339 15 13.3333C15.6944 13.3333 16.2847 13.5764 16.7708 14.0625C17.2569 14.5486 17.5 15.1389 17.5 15.8333C17.5 16.5278 17.2569 17.118 16.7708 17.6042C16.2847 18.0903 15.6944 18.3333 15 18.3333Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
           
          </div>
        </div>
      </div>

      <!-- GALLERY: START -->
      <template v-if="variant === variants.v1">
        <div
          v-if="property.is_rent"
          class="tw-mt-16 tw-w-full"
          :class="!isMobileDevice ? 'tw-grid tw-grid-cols-12 tw-gap-x-3' : ''"
        >
          <div
            v-if="!isMobileDevice"
            class="property-detail-image-container tw-col-span-12 tw-h-full tw-w-full lg:tw-col-span-6"
            @click="onClickedImage(null)"
          >
            <library-image
              :src="primaryFivePhotos[0].background"
              image-class="tw-h-full tw-cursor-pointer"
              alt="property first image"
              :title="property.advert_heading"
              @click="onClickedImage(primaryFivePhotos[0])"
              :design-width="771"
              :design-height="512"
              :style="`border-radius: var(--rounded)`"
              :blur="imageBlurFilter"
              :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
            >
              <template #overlay-item>
                <div class="nc-first-image-overlay-item">
                  <div v-if="property && property.medias" style="" class="tw-text-md tw-px-2 tw-py-1">
                    1/{{ property.medias.length }}
                  </div>
                </div>
              </template>
            </library-image>
          </div>
          <div
            v-if="!isMobileDevice"
            class="tw-col-span-12 tw-grid tw-h-full tw-grid-cols-12 tw-gap-x-3 md:tw-col-span-6"
          >
            <div class="tw-col-span-6 tw-flex tw-flex-row tw-gap-y-3 md:tw-flex-col">
              <library-image
                :src="primaryFivePhotos[1].background"
                alt="property first image"
                image-class="tw-cursor-pointer"
                @click="onClickedImage(primaryFivePhotos[1])"
                :title="property.advert_heading"
                :design-width="364"
                :design-height="246"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
              />

              <library-image
                :src="primaryFivePhotos[2].background"
                alt="property second image"
                image-class="tw-cursor-pointer"
                @click="onClickedImage(primaryFivePhotos[2])"
                :title="property.advert_heading"
                :design-width="364"
                :design-height="246"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
              />
            </div>
            <div class="tw-col-span-6 tw-flex tw-flex-row tw-gap-y-3 md:tw-flex-col">
              <library-image
                :src="primaryFivePhotos[3].background"
                image-class="tw-cursor-pointer"
                @click="onClickedImage(primaryFivePhotos[3])"
                :design-width="364"
                :design-height="246"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
              />
              <library-image
                :src="primaryFivePhotos[4].background"
                image-class="tw-cursor-pointer"
                @click="onClickedImage(primaryFivePhotos[4])"
                :design-width="364"
                :design-height="246"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
              />
            </div>
          </div>
          <div v-else-if="isMobileDevice" class="n-main-container tw-w-screen">
            <Swiper
              :modules="[SwiperNavigation]"
              :pagination="true"
              :slides-per-view="1"
              :space-between="1"
              :loop="true"
              effect="fade"
              :clickable="true"
              :navigation="{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              }"
              class="tw-w-full"
              @swiper="onSwiper"
            >
              <SwiperSlide v-for="(item, index) in primaryFivePhotos" :key="index" class="tw-w-full">
                <library-image
                  :src="item.background"
                  @click="onClickedImage(item)"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                />
              </SwiperSlide>
              <div class="tw-flex tw-items-center tw-justify-between">
                <div class="swiper-button-prev tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3">
                  <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18.75 7.5H5.25C4.83 7.5 4.5 7.17 4.5 6.75C4.5 6.33 4.83 6 5.25 6H18.75C19.17 6 19.5 6.33 19.5 6.75C19.5 7.17 19.17 7.5 18.75 7.5Z"
                      fill="black"
                    />
                    <path
                      d="M9 12.75C8.90164 12.7512 8.80411 12.7318 8.71369 12.6931C8.62328 12.6543 8.54197 12.5971 8.475 12.525L3.225 7.275C2.925 6.975 2.925 6.51 3.225 6.21L8.475 0.975C8.775 0.675 9.24 0.675 9.54 0.975C9.84 1.275 9.84 1.74 9.54 2.04L4.815 6.765L9.54 11.49C9.84 11.79 9.84 12.255 9.54 12.555C9.39 12.705 9.195 12.78 9.015 12.78L9 12.75Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div class="swiper-button-next tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3">
                  <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M5.25 7.5H18.75C19.17 7.5 19.5 7.17 19.5 6.75C19.5 6.33 19.17 6 18.75 6H5.25C4.83 6 4.5 6.33 4.5 6.75C4.5 7.17 4.83 7.5 5.25 7.5Z"
                      fill="black"
                    />
                    <path
                      d="M15 12.75C15.0984 12.7512 15.1959 12.7318 15.2863 12.6931C15.3767 12.6543 15.458 12.5971 15.525 12.525L20.775 7.275C21.075 6.975 21.075 6.51 20.775 6.21L15.525 0.975C15.225 0.675 14.76 0.675 14.46 0.975C14.16 1.275 14.16 1.74 14.46 2.04L19.185 6.765L14.46 11.49C14.16 11.79 14.16 12.255 14.46 12.555C14.61 12.705 14.805 12.78 14.985 12.78L15 12.75Z"
                      fill="black"
                    />
                  </svg>
                </div>
              </div>
            </Swiper>
          </div>
        </div>
        <!-- Sale -->
        <div v-else class="tw-mt-16 tw-w-screen tw-gap-x-1">
          <Swiper
            :modules="[SwiperNavigation]"
            :pagination="true"
            :slides-per-view="3"
            :space-between="3"
            :loop="true"
            effect="fade"
            :clickable="true"
            :navigation="{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }"
            :breakpoints="{
              320: {
                slidesPerView: 1,
                spaceBetween: 3,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 3,
              },
            }"
            class="tw-w-full"
            @swiper="onSwiper"
          >
            <SwiperSlide v-for="(item, index) in property.medias" :key="index">
              <div>
                <library-image
                  :src="item.background"
                  @click="onClickedImage(item)"
                  :design-width="638"
                  :design-height="430"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                >
                  <template #overlay-item>
                    <div v-if="index === 1">
                      <div v-if="property.is_locked" class="pre-market-property-badge tw-text-center">
                        <h3 class="tw-text-white">
                          Pre-Market<br />
                          Property
                        </h3>
                      </div>
                      <div class="nc-first-image-overlay-item">
                        <div v-if="property && property.medias" style="" class="tw-text-md tw-px-2 tw-py-1">
                          1/{{ property.medias.length }}
                        </div>
                      </div>
                    </div>
                  </template>
                </library-image>
              </div>
            </SwiperSlide>
            <div class="tw-flex tw-items-center tw-justify-between">
              <div class="swiper-button-prev tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3">
                <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18.75 7.5H5.25C4.83 7.5 4.5 7.17 4.5 6.75C4.5 6.33 4.83 6 5.25 6H18.75C19.17 6 19.5 6.33 19.5 6.75C19.5 7.17 19.17 7.5 18.75 7.5Z"
                    fill="black"
                  />
                  <path
                    d="M9 12.75C8.90164 12.7512 8.80411 12.7318 8.71369 12.6931C8.62328 12.6543 8.54197 12.5971 8.475 12.525L3.225 7.275C2.925 6.975 2.925 6.51 3.225 6.21L8.475 0.975C8.775 0.675 9.24 0.675 9.54 0.975C9.84 1.275 9.84 1.74 9.54 2.04L4.815 6.765L9.54 11.49C9.84 11.79 9.84 12.255 9.54 12.555C9.39 12.705 9.195 12.78 9.015 12.78L9 12.75Z"
                    fill="black"
                  />
                </svg>
              </div>
              <div class="swiper-button-next tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3">
                <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5.25 7.5H18.75C19.17 7.5 19.5 7.17 19.5 6.75C19.5 6.33 19.17 6 18.75 6H5.25C4.83 6 4.5 6.33 4.5 6.75C4.5 7.17 4.83 7.5 5.25 7.5Z"
                    fill="black"
                  />
                  <path
                    d="M15 12.75C15.0984 12.7512 15.1959 12.7318 15.2863 12.6931C15.3767 12.6543 15.458 12.5971 15.525 12.525L20.775 7.275C21.075 6.975 21.075 6.51 20.775 6.21L15.525 0.975C15.225 0.675 14.76 0.675 14.46 0.975C14.16 1.275 14.16 1.74 14.46 2.04L19.185 6.765L14.46 11.49C14.16 11.79 14.16 12.255 14.46 12.555C14.61 12.705 14.805 12.78 14.985 12.78L15 12.75Z"
                    fill="black"
                  />
                </svg>
              </div>
            </div>
          </Swiper>
        </div>
      </template>
      <!-- GALLERY: END -->

      <!-- variant v2 for gallery -->
  <template v-else-if="variant === variants.v2 && vars.galleryVersionText === 'v2'">
  <div v-if="property.featured_video && !property.is_locked" class="tw-w-full tw-py-5">
    <!-- DESKTOP GRID -->
    <div v-if="!isMobileDevice" class="tw-grid tw-grid-cols-[2.5fr_7.25fr_2.25fr] tw-gap-5">
      <!-- SOL: VİDEO -->
      <div class="tw-relative">
        <div class="tw-aspect-[9/16] tw-h-full tw-w-full">
          <library-video-embed
            class="tw-h-full tw-w-full"
            :video-url="property.featured_video?.mediaLink"
            :custom-classes="'tw-absolute tw-h-full tw-w-full tw-rounded-[var(--rounded)]'"
            :design-width="328"
            :design-height="584"
            :cover-photo="imageBlurFilter ? primaryFivePhotos[0]?.background : undefined"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
            :use-library-image="true"
          />
        </div>
      </div>

      <!-- ORTA: İLK FOTO -->
      <div>
        <library-image
          :src="primaryFivePhotos[0]?.background"
          image-class="tw-h-full tw-cursor-pointer"
          alt="property first image"
          :title="property.advert_heading"
          @click="onClickedImage(primaryFivePhotos[0])"
          :design-width="878"
          :design-height="585"
          :style="`border-radius: var(--rounded)`"
          :blur="imageBlurFilter"
          :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
        >
          <template #overlay-item>
            <div class="nc-first-image-overlay-item">
              <div
                v-if="property?.medias"
                style="border-radius: var(--rounded-sm)"
                class="tw-text-md tw-bg-white tw-px-2 tw-py-1"
              >
                1/{{ property.medias.length }}
              </div>
            </div>
          </template>
        </library-image>
      </div>

      <!-- SAĞ: 3 FOTO -->
      <div class="tw-flex tw-flex-col tw-justify-between">
        <library-image
          :src="primaryFivePhotos[1]?.background"
          alt="property second image"
          image-class="tw-cursor-pointer"
          @click="onClickedImage(primaryFivePhotos[1])"
          :title="property.advert_heading"
          :design-width="270"
          :design-height="180"
          :style="`border-radius: var(--rounded)`"
          :blur="imageBlurFilter"
          :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
        />
        <library-image
          :src="primaryFivePhotos[2]?.background"
          alt="property third image"
          image-class="tw-cursor-pointer"
          @click="onClickedImage(primaryFivePhotos[2])"
          :title="property.advert_heading"
          :design-width="270"
          :design-height="180"
          :style="`border-radius: var(--rounded)`"
          :blur="imageBlurFilter"
          :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
        />
        <library-image
          :src="primaryFivePhotos[3]?.background"
          alt="property fourth image"
          image-class="tw-cursor-pointer"
          @click="onClickedImage(primaryFivePhotos[3])"
          :title="property.advert_heading"
          :design-width="270"
          :design-height="180"
          :style="`border-radius: var(--rounded)`"
          :blur="imageBlurFilter"
          :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
        >
          <template #overlay-item>
            <div
              v-if="property?.medias"
              class="tw-absolute tw-inset-0 tw-z-10 tw-h-full tw-w-full tw-bg-black tw-opacity-30"
              style="border-radius: var(--rounded-sm)"
            ></div>
            <h3 class="tw-z-20 tw-text-white">+{{ property.medias.length - 4 }}</h3>
          </template>
        </library-image>
      </div>
    </div>

    <!-- MOBILE: TÜM FOTOĞRAFLAR (VİDEO VE KAPAĞI HARİÇ) -->
    <div v-else-if="isMobileDevice">
      <Swiper
        :modules="[SwiperNavigation]"
        :pagination="true"
        :slides-per-view="1"
        :space-between="1"
        :loop="allPhotos.length > 1"
        effect="fade"
        :clickable="true"
        :navigation="{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }"
        class="tw-w-full"
        @swiper="onSwiper"
      >
        <SwiperSlide v-for="(item, index) in allPhotos" :key="item.__key || index" class="tw-w-full">
          <library-image
            :src="item.background"
            @click="onClickedImage(item)"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          />
        </SwiperSlide>

        <div class="tw-flex tw-items-center tw-justify-between">
          <div class="swiper-button-prev tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3">
            <!-- SOL OK SVG -->
            <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.75 7.5H5.25C4.83 7.5 4.5 7.17 4.5 6.75C4.5 6.33 4.83 6 5.25 6H18.75C19.17 6 19.5 6.33 19.5 6.75C19.5 7.17 19.17 7.5 18.75 7.5Z" fill="black"/>
              <path d="M9 12.75C8.90164 12.7512 8.80411 12.7318 8.71369 12.6931C8.62328 12.6543 8.54197 12.5971 8.475 12.525L3.225 7.275C2.925 6.975 2.925 6.51 3.225 6.21L8.475 0.975C8.775 0.675 9.24 0.675 9.54 0.975C9.84 1.275 9.84 1.74 9.54 2.04L4.815 6.765L9.54 11.49C9.84 11.79 9.84 12.255 9.54 12.555C9.39 12.705 9.195 12.78 9.015 12.78L9 12.75Z" fill="black"/>
            </svg>
          </div>
          <div class="swiper-button-next tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3">
            <!-- SAĞ OK SVG -->
            <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.25 7.5H18.75C19.17 7.5 19.5 7.17 19.5 6.75C19.5 6.33 19.17 6 18.75 6H5.25C4.83 6 4.5 6.33 4.5 6.75C4.5 7.17 4.83 7.5 5.25 7.5Z" fill="black"/>
              <path d="M15 12.75C15.0984 12.7512 15.1959 12.7318 15.2863 12.6931C15.3767 12.6543 15.458 12.5971 15.525 12.525L20.775 7.275C21.075 6.975 21.075 6.51 20.775 6.21L15.525 0.975C15.225 0.675 14.76 0.675 14.46 0.975C14.16 1.275 14.16 1.74 14.46 2.04L19.185 6.765L14.46 11.49C14.16 11.79 14.16 12.255 14.46 12.555C14.61 12.705 14.805 12.78 14.985 12.78L15 12.75Z" fill="black"/>
            </svg>
          </div>
        </div>
      </Swiper>
    </div>
  </div>

  <!-- VİDEO YOKSA -->
  <div
    v-else
    class="tw-mt-16 tw-w-full tw-pb-16"
    :class="!isMobileDevice ? 'tw-grid tw-grid-cols-12 tw-gap-x-3' : ''"
  >
    <!-- DESKTOP -->
    <div
      v-if="!isMobileDevice"
      class="image-wrapper image-container property-detail-image-container tw-col-span-12 tw-h-full tw-w-full lg:tw-col-span-7"
      @click="onClickedImage(null)"
    >
      <library-image
        :src="primarySevenPhotos[0]?.background"
        image-class="tw-h-full tw-cursor-pointer"
        alt="property first image"
        :title="property.advert_heading"
        @click="onClickedImage(primarySevenPhotos[0])"
        :design-width="900"
        :design-height="611"
        :style="`border-radius: var(--rounded)`"
        :blur="imageBlurFilter"
        :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
        :use-default-radius="true"
      />
      <div class="nc-first-image-overlay-item">
        <div
          v-if="property?.medias"
          style="background-color: var(--white); color: var(--dark-brown)"
          class="px-2 py-1"
        >
          1/{{ property.medias.length }}
        </div>
      </div>
    </div>

    <!-- DESKTOP: küçük resimler -->
    <div v-if="!isMobileDevice" class="tw-col-span-12 tw-grid tw-h-full tw-grid-cols-12 tw-gap-x-3 md:tw-col-span-5">
      <!-- soldaki 3 -->
      <div class="tw-col-span-6 tw-flex tw-flex-row tw-gap-y-3 md:tw-flex-col">
        <library-image
          v-for="(img, idx) in [primarySevenPhotos[1], primarySevenPhotos[2], primarySevenPhotos[3]]"
          :key="idx"
          :src="img?.background"
          image-class="tw-cursor-pointer"
          @click="onClickedImage(img)"
          :title="property.advert_heading"
          :design-width="276"
          :design-height="184"
          :style="`border-radius: var(--rounded)`"
          :blur="imageBlurFilter"
          :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          :use-default-radius="true"
        />
      </div>
      <!-- sağdaki 3 -->
      <div class="tw-col-span-6 tw-flex tw-flex-row tw-gap-y-3 md:tw-flex-col">
        <library-image
          v-for="(img, idx) in [primarySevenPhotos[4], primarySevenPhotos[5], primarySevenPhotos[6]]"
          :key="`r-${idx}`"
          :src="img?.background"
          image-class="tw-cursor-pointer"
          @click="onClickedImage(img)"
          :title="property.advert_heading"
          :design-width="276"
          :design-height="184"
          :style="`border-radius: var(--rounded)`"
          :blur="imageBlurFilter"
          :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          :use-default-radius="true"
        >
          <template v-if="idx === 2" #overlay-item>
            <div
              v-if="property?.medias"
              class="tw-absolute tw-inset-0 tw-z-10 tw-h-full tw-w-full tw-bg-black tw-opacity-30"
              style="border-radius: var(--rounded-sm)"
            ></div>
            <h3 class="tw-z-20 tw-text-white">+{{ property.medias.length - 4 }}</h3>
          </template>
        </library-image>
      </div>
    </div>

    <!-- MOBILE -->
    <div v-else-if="isMobileDevice" class="n-main-container tw-w-screen">
      <Swiper
        :modules="[SwiperNavigation]"
        :pagination="true"
        :slides-per-view="1"
        :space-between="1"
        :loop="allPhotos.length > 1"
        effect="fade"
        :clickable="true"
        :navigation="{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }"
        class="tw-w-full"
        @swiper="onSwiper"
      >
        <SwiperSlide v-for="(item, index) in allPhotos" :key="item.__key || index" class="tw-w-full">
          <library-image
            :src="item.background"
            @click="onClickedImage(item)"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          />
        </SwiperSlide>

        <div class="tw-flex tw-items-center tw-justify-between">
          <div class="swiper-button-prev tw-flex !tw-h-10 !tw-w-10 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-bg-white">
            <!-- SOL OK SVG -->
            <svg
              width="24"
              height="14"
              viewBox="0 0 24 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="!tw-w-6"
            >
              <path
                d="M18.75 7.5H5.25C4.83 7.5 4.5 7.17 4.5 6.75C4.5 6.33 4.83 6 5.25 6H18.75C19.17 6 19.5 6.33 19.5 6.75C19.5 7.17 19.17 7.5 18.75 7.5Z"
                fill="black"
              />
              <path
                d="M9 12.75C8.90164 12.7512 8.80411 12.7318 8.71369 12.6931C8.62328 12.6543 8.54197 12.5971 8.475 12.525L3.225 7.275C2.925 6.975 2.925 6.51 3.225 6.21L8.475 0.975C8.775 0.675 9.24 0.675 9.54 0.975C9.84 1.275 9.84 1.74 9.54 2.04L4.815 6.765L9.54 11.49C9.84 11.79 9.84 12.255 9.54 12.555C9.39 12.705 9.195 12.78 9.015 12.78L9 12.75Z"
                fill="black"
              />
            </svg>
          </div>
          <div class="swiper-button-next tw-flex !tw-h-10 !tw-w-10 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-bg-white">
            <!-- SAĞ OK SVG -->
            <svg
              width="24"
              height="14"
              viewBox="0 0 24 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="!tw-w-6"
            >
              <path
                d="M5.25 7.5H18.75C19.17 7.5 19.5 7.17 19.5 6.75C19.5 6.33 19.17 6 18.75 6H5.25C4.83 6 4.5 6.33 4.5 6.75C4.5 7.17 4.83 7.5 5.25 7.5Z"
                fill="black"
              />
              <path
                d="M15 12.75C15.0984 12.7512 15.1959 12.7318 15.2863 12.6931C15.3767 12.6543 15.458 12.5971 15.525 12.525L20.775 7.275C21.075 6.975 21.075 6.51 20.775 6.21L15.525 0.975C15.225 0.675 14.76 0.675 14.46 0.975C14.16 1.275 14.16 1.74 14.46 2.04L19.185 6.765L14.46 11.49C14.16 11.79 14.16 12.255 14.46 12.555C14.61 12.705 14.805 12.78 14.985 12.78L15 12.75Z"
                fill="black"
              />
            </svg>
          </div>
        </div>
      </Swiper>
    </div>
  </div>
</template>


      <!-- V3 GALLERY -->
      <!-- ✨ NEW: variant v3 for gallery (Masaüstü özel düzen; mobil aynı kalır) -->
      <template v-else-if="variant === variants.v3">
        <!-- Desktop -->
        <div v-if="!isMobileDevice" class="tw-mb-6 tw-mt-16 tw-w-full">
          <div class="tw-grid tw-grid-cols-12 tw-items-stretch tw-gap-5">
            <!-- SOL: Featured video VARSA -->
            <div v-if="property.featured_video?.mediaLink" class="tw-col-span-12 lg:tw-col-span-3">
              <div class="tw-relative tw-h-full tw-w-full">
                <library-video-embed
                  class="tw-h-full tw-w-full tw-rounded-[var(--rounded)]"
                  :video-url="property.featured_video.mediaLink"
                  :custom-classes="'tw-h-full tw-w-full tw-rounded-[var(--rounded)]'"
                  :design-width="328"
                  :design-height="584"
                  :cover-photo="
                    imageBlurFilter ? primarySevenPhotos[0]?.background || primaryFivePhotos[0]?.background : undefined
                  "
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                  :use-library-image="true"
                />
              </div>
            </div>

            <!-- ORTA: Büyük foto (video varsa 6/12, yoksa 9/12) -->
            <div
              :class="property.featured_video?.mediaLink ? 'lg:tw-col-span-6' : 'lg:tw-col-span-9'"
              class="tw-col-span-12"
            >
              <library-image
                :src="primarySevenPhotos[0]?.background || primaryFivePhotos[0]?.background"
                image-class="tw-h-full tw-w-full tw-object-cover tw-cursor-pointer"
                :title="property.advert_heading"
                :design-width="900"
                :design-height="585"
                :style="`border-radius: var(--rounded); height: 100%`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                @click="onClickedImage(primarySevenPhotos[0] || primaryFivePhotos[0])"
              >
              </library-image>
            </div>

            <!-- SAĞ: İki küçük foto + See all photos -->
            <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-5 lg:tw-col-span-3">
              <library-image
                :src="primarySevenPhotos[1]?.background || primaryFivePhotos[1]?.background"
                image-class="tw-w-full tw-object-cover tw-cursor-pointer"
                :title="property.advert_heading"
                :design-width="270"
                :design-height="180"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                @click="onClickedImage(primarySevenPhotos[1] || primaryFivePhotos[1])"
              />
              <library-image
                :src="primarySevenPhotos[2]?.background || primaryFivePhotos[2]?.background"
                image-class="tw-w-full tw-object-cover tw-cursor-pointer"
                :title="property.advert_heading"
                :design-width="270"
                :design-height="180"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                @click="onClickedImage(primarySevenPhotos[2] || primaryFivePhotos[2])"
              />

              <button
                class="n-secondary tw-mt-2"
                @click="onClickedImage(primarySevenPhotos[0] || primaryFivePhotos[0])"
              >
                SEE ALL PHOTOS
              </button>
            </div>
          </div>
        </div>

        <!-- Mobile slider -->
        <div v-else class="tw-mb-4 tw-mt-10 tw-w-screen">
          <Swiper
            :modules="[SwiperNavigation]"
            :pagination="true"
            :slides-per-view="1"
            :space-between="1"
            :loop="true"
            effect="fade"
            :clickable="true"
            :navigation="{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }"
            class="tw-w-full"
            @swiper="onSwiper"
          >
            <SwiperSlide
              v-for="(item, index) in property.medias || primarySevenPhotos || primaryFivePhotos"
              :key="index"
              class="tw-w-full"
            >
              <library-image
                :src="item.background"
                @click="onClickedImage(item)"
                :blur="imageBlurFilter"
                :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
              />
            </SwiperSlide>
            <div class="tw-flex tw-items-center tw-justify-between">
              <div class="swiper-button-prev tw-cursor-pointer tw-rounded-md tw-px-2 tw-py-5 lg:tw-px-3">
                <!-- left icon -->
                <svg width="44" height="43" viewBox="0 0 44 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g filter="url(#filter0_d_54_3084)">
                    <rect
                      width="35"
                      height="35"
                      rx="17.5"
                      transform="matrix(-1 0 0 1 39.5 0)"
                      fill="white"
                      shape-rendering="crispEdges"
                    />
                    <path
                      d="M21.207 12.293C21.0195 12.1056 20.7652 12.0002 20.5 12.0002C20.2348 12.0002 19.9805 12.1056 19.793 12.293L15.293 16.793C15.1055 16.9806 15.0002 17.2349 15.0002 17.5C15.0002 17.7652 15.1055 18.0195 15.293 18.207L19.793 22.707C19.9816 22.8892 20.2342 22.99 20.4964 22.9877C20.7586 22.9854 21.0094 22.8803 21.1948 22.6948C21.3802 22.5094 21.4854 22.2586 21.4877 21.9964C21.49 21.7342 21.3892 21.4816 21.207 21.293L18.5 18.5H28C28.2652 18.5 28.5196 18.3947 28.7071 18.2071C28.8946 18.0196 29 17.7652 29 17.5C29 17.2348 28.8946 16.9805 28.7071 16.7929C28.5196 16.6054 28.2652 16.5 28 16.5H18.5L21.207 13.707C21.3945 13.5195 21.4998 13.2652 21.4998 13C21.4998 12.7349 21.3945 12.4806 21.207 12.293Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_54_3084"
                      x="0.5"
                      y="0"
                      width="43"
                      height="43"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_3084" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_54_3084" result="shape" />
                    </filter>
                  </defs>
                </svg>
              </div>
              <div class="swiper-button-next tw-cursor-pointer tw-rounded-md tw-px-2 tw-py-5 lg:tw-px-3">
                <!-- right icon -->
                <svg width="44" height="43" viewBox="0 0 44 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g filter="url(#filter0_d_54_3081)">
                    <rect x="4.5" width="35" height="35" rx="17.5" fill="white" shape-rendering="crispEdges" />
                    <path
                      d="M22.793 12.293C22.9805 12.1056 23.2348 12.0002 23.5 12.0002C23.7652 12.0002 24.0195 12.1056 24.207 12.293L28.707 16.793C28.8945 16.9806 28.9998 17.2349 28.9998 17.5C28.9998 17.7652 28.8945 18.0195 28.707 18.207L24.207 22.707C24.0184 22.8892 23.7658 22.99 23.5036 22.9877C23.2414 22.9854 22.9906 22.8803 22.8052 22.6948C22.6198 22.5094 22.5146 22.2586 22.5123 21.9964C22.51 21.7342 22.6108 21.4816 22.793 21.293L25.5 18.5H16C15.7348 18.5 15.4804 18.3947 15.2929 18.2071C15.1054 18.0196 15 17.7652 15 17.5C15 17.2348 15.1054 16.9805 15.2929 16.7929C15.4804 16.6054 15.7348 16.5 16 16.5H25.5L22.793 13.707C22.6055 13.5195 22.5002 13.2652 22.5002 13C22.5002 12.7349 22.6055 12.4806 22.793 12.293Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_54_3081"
                      x="0.5"
                      y="0"
                      width="43"
                      height="43"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_3081" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_54_3081" result="shape" />
                    </filter>
                  </defs>
                </svg>
              </div>
            </div>
          </Swiper>
        </div>
        <div v-if="property.featured_video?.mediaLink" class="tw-mb-4 tw-mt-4">
          <div class="tw-relative tw-aspect-[16/9] tw-w-full">
            <library-video-embed
              :video-url="property.featured_video.mediaLink"
              :custom-classes="'tw-absolute tw-inset-0 tw-h-full tw-w-full tw-rounded-[var(--rounded)]'"
              :design-width="640"
              :design-height="360"
              :cover-photo="
                imageBlurFilter ? primarySevenPhotos[0]?.background || primaryFivePhotos[0]?.background : undefined
              "
              :blur="imageBlurFilter"
              :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
              :use-library-image="true"
            />
          </div>
        </div>
      </template>
      <!-- GALLERY: END -->

        <template v-else-if="variant === variants.v4">
        <!-- Desktop -->
      <!-- Desktop -->
<div v-if="!isMobileDevice" class="tw-mb-6 tw-mt-16 tw-w-full">
  <div class="tw-grid tw-grid-cols-12 tw-gap-5 tw-items-stretch">

    <!-- VİDEO VARSA -->
    <template v-if="property.featured_video?.mediaLink">
      <!-- Sol: Video 3/12 -->
      <div class="tw-col-span-12 lg:tw-col-span-3">
        <library-video-embed
          :video-url="property.featured_video.mediaLink"
          :custom-classes="'tw-h-full tw-w-full tw-rounded-[var(--rounded)]'"
          class="tw-h-full tw-w-full tw-rounded-[var(--rounded)]"
          :design-width="328"
          :design-height="584"
          :cover-photo="imageBlurFilter ? (primarySevenPhotos[0]?.background || primaryFivePhotos[0]?.background) : undefined"
          :blur="imageBlurFilter"
          :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          :use-library-image="true"
        />
      </div>

      <!-- Orta+Sağ: 9/12 iç grid (4 kolon, 2 satır) -->
      <div class="tw-col-span-12 lg:tw-col-span-9">
        <div class="tw-grid tw-grid-cols-4 tw-gap-5 tw-h-full">
          <!-- Sol büyük: 2 kolon x tam yükseklik -->
          <div class="tw-col-span-2 tw-h-full">
            <library-image
              :src="primarySevenPhotos[0]?.background || primaryFivePhotos[0]?.background"
              image-class="tw-h-full tw-w-full tw-object-cover tw-cursor-pointer"
              :title="property.advert_heading"
              :design-width="900"
              :design-height="585"
              :style="`border-radius: var(--rounded); height: 100%`"
              :blur="imageBlurFilter"
              :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
              @click="onClickedImage(primarySevenPhotos[0] || primaryFivePhotos[0])"
            />
          </div>

          <!-- Sağ taraf: 2 kolon için flex container -->
          <div class="tw-col-span-2 tw-flex tw-flex-col tw-gap-5 tw-h-full">
            <!-- Üst satır: 2 fotoğraf -->
            <div class="tw-flex tw-gap-5 tw-flex-1">
              <div class="tw-flex-1">
                <library-image
                  :src="(primarySevenPhotos[1]?.background) || (primaryFivePhotos[1]?.background)"
                  image-class="tw-h-full tw-w-full tw-object-cover tw-cursor-pointer"
                  :title="property.advert_heading"
                  :design-width="270"
                  :design-height="180"
                  :style="`border-radius: var(--rounded)`"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                  @click="onClickedImage(primarySevenPhotos[1] || primaryFivePhotos[1])"
                />
              </div>
              <div class="tw-flex-1">
                <library-image
                  :src="(primarySevenPhotos[2]?.background) || (primaryFivePhotos[2]?.background)"
                  image-class="tw-h-full tw-w-full tw-object-cover tw-cursor-pointer"
                  :title="property.advert_heading"
                  :design-width="270"
                  :design-height="180"
                  :style="`border-radius: var(--rounded)`"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                  @click="onClickedImage(primarySevenPhotos[2] || primaryFivePhotos[2])"
                />
              </div>
            </div>
            
            <!-- Alt satır: 2 fotoğraf -->
            <div class="tw-flex tw-gap-5 tw-flex-1">
              <div class="tw-flex-1">
                <library-image
                  :src="(primarySevenPhotos[3]?.background) || (primaryFivePhotos[3]?.background)"
                  image-class="tw-h-full tw-w-full tw-object-cover tw-cursor-pointer"
                  :title="property.advert_heading"
                  :design-width="270"
                  :design-height="180"
                  :style="`border-radius: var(--rounded)`"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                  @click="onClickedImage(primarySevenPhotos[3] || primaryFivePhotos[3])"
                />
              </div>
              
              <!-- 4. küçük (See all +N overlay) -->
              <div class="tw-flex-1">
                <div class="tw-relative tw-h-full tw-w-full tw-cursor-pointer"
                     @click="onClickedImage(primarySevenPhotos[0] || primaryFivePhotos[0])">
                  <library-image
                    :src="(primarySevenPhotos[4]?.background) || (primaryFivePhotos[4]?.background) || (primarySevenPhotos[2]?.background) || (primaryFivePhotos[2]?.background)"
                    image-class="tw-h-full tw-w-full tw-object-cover"
                    :title="property.advert_heading"
                    :design-width="270"
                    :design-height="180"
                    :style="`border-radius: var(--rounded)`"
                    :blur="imageBlurFilter"
                    :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                  />
                  <div class="tw-absolute tw-inset-0 tw-rounded-[var(--rounded)] tw-bg-black/40 tw-grid tw-place-items-center">
                    <div class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-white">
                      <span class="tw-text-xl tw-font-semibold">+{{ Math.max(0, (property?.medias?.length || 0) - 5) }}</span>
                      <span class="tw-text-sm tw-font-medium tw-uppercase tracking-wide">See all</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- VİDEO YOKSA -->
    <template v-else>
      <!-- Tam genişlikte iç grid: 4 kolon -->
      <div class="tw-col-span-12">
        <div class="tw-grid tw-grid-cols-4 tw-gap-5 tw-h-full">
          <!-- Sol büyük: 2 kolon x tam yükseklik -->
          <div class="tw-col-span-2 tw-pt-1 tw-h-full">
            <library-image
              :src="primarySevenPhotos[0]?.background || primaryFivePhotos[0]?.background"
              image-class="tw-h-full tw-w-full tw-object-cover tw-cursor-pointer"
              :title="property.advert_heading"
              :design-width="900"
              :design-height="585"
              :style="`border-radius: var(--rounded); height: 100%`"
              :blur="imageBlurFilter"
              :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
              @click="onClickedImage(primarySevenPhotos[0] || primaryFivePhotos[0])"
            />
          </div>

          <!-- Sağ taraf: 2 kolon için flex container -->
          <div class="tw-col-span-2 tw-flex   tw-flex-col tw-gap-2 tw-h-full">
            <!-- Üst satır: 2 fotoğraf -->
            <div class="tw-flex tw-gap-5 tw-flex-1">
              <div class="tw-flex-1">
                <library-image
                  :src="(primarySevenPhotos[1]?.background) || (primaryFivePhotos[1]?.background)"
                  image-class="tw-h-full tw-w-full tw-object-cover tw-cursor-pointer"
                  :title="property.advert_heading"
                  :design-width="270"
                  :design-height="180"
                  :style="`border-radius: var(--rounded)`"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                  @click="onClickedImage(primarySevenPhotos[1] || primaryFivePhotos[1])"
                />
              </div>
              <div class="tw-flex-1">
                <library-image
                  :src="(primarySevenPhotos[2]?.background) || (primaryFivePhotos[2]?.background)"
                  image-class="tw-h-full tw-w-full tw-object-cover tw-cursor-pointer"
                  :title="property.advert_heading"
                  :design-width="270"
                  :design-height="180"
                  :style="`border-radius: var(--rounded)`"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                  @click="onClickedImage(primarySevenPhotos[2] || primaryFivePhotos[2])"
                />
              </div>
            </div>
            
            <!-- Alt satır: 2 fotoğraf -->
            <div class="tw-flex tw-gap-5 tw-flex-1">
              <div class="tw-flex-1">
                <library-image
                  :src="(primarySevenPhotos[3]?.background) || (primaryFivePhotos[3]?.background)"
                  image-class="tw-h-full tw-w-full tw-object-cover tw-cursor-pointer"
                  :title="property.advert_heading"
                  :design-width="270"
                  :design-height="180"
                  :style="`border-radius: var(--rounded)`"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                  @click="onClickedImage(primarySevenPhotos[3] || primaryFivePhotos[3])"
                />
              </div>
              
              <!-- 4. küçük +N overlay -->
              <div class="tw-flex-1">
                <div class="tw-relative tw-h-full tw-w-full tw-cursor-pointer"
                     @click="onClickedImage(primarySevenPhotos[0] || primaryFivePhotos[0])">
                  <library-image
                    :src="(primarySevenPhotos[4]?.background) || (primaryFivePhotos[4]?.background) || (primarySevenPhotos[2]?.background) || (primaryFivePhotos[2]?.background)"
                    image-class="tw-h-full tw-w-full tw-object-cover"
                    :title="property.advert_heading"
                    :design-width="270"
                    :design-height="180"
                    :style="`border-radius: var(--rounded)`"
                    :blur="imageBlurFilter"
                    :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                  />
                  <div class="tw-absolute tw-inset-0 tw-rounded-[var(--rounded)] tw-bg-black/40 tw-grid tw-place-items-center">
                    <div class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-white">
                      <h3>
  +{{ Math.max(0, (property?.medias?.length || 0) - 4) }}
</h3>

                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

  </div>
</div>

        <!-- Mobile slider -->
        <div v-else class="tw-mb-4 tw-mt-10 tw-w-screen">
          <Swiper
            :modules="[SwiperNavigation]"
            :pagination="true"
            :slides-per-view="1"
            :space-between="1"
            :loop="true"
            effect="fade"
            :clickable="true"
            :navigation="{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }"
            class="tw-w-full"
            @swiper="onSwiper"
          >
            <SwiperSlide
              v-for="(item, index) in property.medias || primarySevenPhotos || primaryFivePhotos"
              :key="index"
              class="tw-w-full"
            >
              <library-image
                :src="item.background"
                @click="onClickedImage(item)"
                :blur="imageBlurFilter"
                :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
              />
            </SwiperSlide>
            <div class="tw-flex tw-items-center tw-justify-between">
              <div class="swiper-button-prev tw-cursor-pointer tw-rounded-md tw-px-2 tw-py-5 lg:tw-px-3">
                <!-- left icon -->
                <svg width="44" height="43" viewBox="0 0 44 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g filter="url(#filter0_d_54_3084)">
                    <rect
                      width="35"
                      height="35"
                      rx="17.5"
                      transform="matrix(-1 0 0 1 39.5 0)"
                      fill="white"
                      shape-rendering="crispEdges"
                    />
                    <path
                      d="M21.207 12.293C21.0195 12.1056 20.7652 12.0002 20.5 12.0002C20.2348 12.0002 19.9805 12.1056 19.793 12.293L15.293 16.793C15.1055 16.9806 15.0002 17.2349 15.0002 17.5C15.0002 17.7652 15.1055 18.0195 15.293 18.207L19.793 22.707C19.9816 22.8892 20.2342 22.99 20.4964 22.9877C20.7586 22.9854 21.0094 22.8803 21.1948 22.6948C21.3802 22.5094 21.4854 22.2586 21.4877 21.9964C21.49 21.7342 21.3892 21.4816 21.207 21.293L18.5 18.5H28C28.2652 18.5 28.5196 18.3947 28.7071 18.2071C28.8946 18.0196 29 17.7652 29 17.5C29 17.2348 28.8946 16.9805 28.7071 16.7929C28.5196 16.6054 28.2652 16.5 28 16.5H18.5L21.207 13.707C21.3945 13.5195 21.4998 13.2652 21.4998 13C21.4998 12.7349 21.3945 12.4806 21.207 12.293Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_54_3084"
                      x="0.5"
                      y="0"
                      width="43"
                      height="43"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_3084" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_54_3084" result="shape" />
                    </filter>
                  </defs>
                </svg>
              </div>
              <div class="swiper-button-next tw-cursor-pointer tw-rounded-md tw-px-2 tw-py-5 lg:tw-px-3">
                <!-- right icon -->
                <svg width="44" height="43" viewBox="0 0 44 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g filter="url(#filter0_d_54_3081)">
                    <rect x="4.5" width="35" height="35" rx="17.5" fill="white" shape-rendering="crispEdges" />
                    <path
                      d="M22.793 12.293C22.9805 12.1056 23.2348 12.0002 23.5 12.0002C23.7652 12.0002 24.0195 12.1056 24.207 12.293L28.707 16.793C28.8945 16.9806 28.9998 17.2349 28.9998 17.5C28.9998 17.7652 28.8945 18.0195 28.707 18.207L24.207 22.707C24.0184 22.8892 23.7658 22.99 23.5036 22.9877C23.2414 22.9854 22.9906 22.8803 22.8052 22.6948C22.6198 22.5094 22.5146 22.2586 22.5123 21.9964C22.51 21.7342 22.6108 21.4816 22.793 21.293L25.5 18.5H16C15.7348 18.5 15.4804 18.3947 15.2929 18.2071C15.1054 18.0196 15 17.7652 15 17.5C15 17.2348 15.1054 16.9805 15.2929 16.7929C15.4804 16.6054 15.7348 16.5 16 16.5H25.5L22.793 13.707C22.6055 13.5195 22.5002 13.2652 22.5002 13C22.5002 12.7349 22.6055 12.4806 22.793 12.293Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_54_3081"
                      x="0.5"
                      y="0"
                      width="43"
                      height="43"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_3081" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_54_3081" result="shape" />
                    </filter>
                  </defs>
                </svg>
              </div>
            </div>
          </Swiper>
        </div>
        <div v-if="property.featured_video?.mediaLink" class="tw-mb-4 tw-mt-4">
          <div class="tw-relative tw-aspect-[16/9] tw-w-full">
            <library-video-embed
              :video-url="property.featured_video.mediaLink"
              :custom-classes="'tw-absolute tw-inset-0 tw-h-full tw-w-full tw-rounded-[var(--rounded)]'"
              :design-width="640"
              :design-height="360"
              :cover-photo="
                imageBlurFilter ? primarySevenPhotos[0]?.background || primaryFivePhotos[0]?.background : undefined
              "
              :blur="imageBlurFilter"
              :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
              :use-library-image="true"
            />
          </div>
        </div>
      </template>

      <!-- tabs -->
      <ul
        v-if="!property.is_locked"
        :class="[
  'nav nav-tabs pxp-nav-tabs tw-mt-3 tw-items-center tw-justify-center',

  variant === variants.v1 && 'tw-flex tw-flex-col tw-gap-10 lg:tw-flex-row',

  // v3 ve v4 mobil düzen (lg altı grid, lg ve üstü yatay)
  (variant === variants.v3 || variant === variants.v4) &&
    'v3-tabs tw-mb-6 tw-mt-6 max-lg:tw-grid max-lg:tw-w-full max-lg:tw-grid-cols-3 max-lg:tw-gap-y-4 lg:tw-flex lg:tw-flex-row lg:tw-gap-10',
]"

      >
        <!-- v1 için -->
        <li v-if="variant === variants.v1" v-for="(tab, tabIndex) in tabs" :key="`tab-v1-${tabIndex}`" class="nav-item">
          <div
            :class="['nav-link tw-cursor-pointer tw-font-bold', activeTab.name === tab.name ? 'active' : '']"
            data-toggle="tab"
            @click="
              () => {
                activeTab.name = tab.name;
                activeTab.title = tab.title;
              }
            "
          >
            {{ tab.title }}
          </div>
        </li>

        <!-- v3 için -->
        <li
          v-if="variant === variants.v3"
          v-for="(tab, tabIndex) in tabs"
          :key="`tab-v3-${tabIndex}`"
          class="nav-item max-lg:tw-text-center"
        >
          <h5
            :class="['nav-link tw-cursor-pointer tw-font-bold', activeTab.name === tab.name ? 'active' : '']"
            :style="activeTab.name === tab.name ? 'color: var(--c-primary)' : ''"
            data-toggle="tab"
            @click="
              () => {
                activeTab.name = tab.name;
                activeTab.title = tab.title;
              }
            "
          >
            {{ tab.title }}
          </h5>
        </li>

        <li
          v-if="variant === variants.v4"
          v-for="(tab, tabIndex) in tabs"
          :key="`tab-v3-${tabIndex}`"
          class="nav-item max-lg:tw-text-center"
        >
          <h5
            :class="['nav-link tw-cursor-pointer tw-font-bold', activeTab.name === tab.name ? 'active' : '']"
            :style="activeTab.name === tab.name ? 'color: var(--c-primary)' : ''"
            data-toggle="tab"
            @click="
              () => {
                activeTab.name = tab.name;
                activeTab.title = tab.title;
              }
            "
          >
            {{ tab.title }}
          </h5>
        </li>
      </ul>

      <!-- tabs end -->
    </section>
    <!-- PROPERTY DETAIL -->
    <section
      v-if="variant === variants.v1 && !property.is_locked"
      class="n-section-primary !tw-pt-0"
      style="background-color: var(--c-section_tertiary)"
    >
      <div>
        <div class="tw-grid tw-grid-cols-12 md:tw-gap-x-10">
          <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8">
            <!-- Property Video, Send Lead: START -->
            <!-- <property-detail-actions
            v-if="isMobileDevice"
            :property="property"
            :component="component"
            class="tw-col-span-12"
            @on-send-lead="onSendLead()"
          /> -->
            <!-- Property Video, Send Lead: END -->

            <div>
              <!-- <library-title text="Property Information" tag="h3"></library-title> -->

              <div class="tab-content tw-mt-4 tw-flex tw-flex-col tw-gap-6">
                <div id="features" role="tabpanel" v-show="activeTab.name === 'features'">
                  <div
                    class="tw-flex tw-flex-col tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="
                      background: var(--c-section_secondary);
                      border-radius: var(--rounded);
                      border-color: var(--c-border);
                    "
                  >
                    <h3>Features</h3>
                    <div class="tw-mt-4 tw-grid tw-grid-cols-12 tw-gap-4">
                      <div
                        v-for="(feature, index) in property.features"
                        :key="`property-feature-${index}`"
                        class="tw-col-span-12 tw-flex tw-h-[40px] tw-items-center tw-gap-x-3 md:tw-col-span-6"
                      >
                        <span>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                              fill="#BFA86C"
                            />
                          </svg>
                        </span>
                        <library-text class="tw-text-sm tw-font-semibold tw-uppercase" :text="feature"> </library-text>
                      </div>
                    </div>
                  </div>
                </div>

                <div id="information" role="tabpanel" v-show="activeTab.name === 'information'">
                  <div
                    class="tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="
                      background: var(--c-section_secondary);
                      border-radius: var(--rounded);
                      border-color: var(--c-border);
                    "
                  >
                    <div class="tw-flex tw-items-center tw-gap-4 tw-pb-8">
                      <div
                        v-if="property.bedroom"
                        class="tw-px-4 tw-py-3"
                        style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                      >
                        <h6>Beds: {{ property.bedroom }}</h6>
                      </div>
                      <div
                        v-if="property.bathroom"
                        class="tw-px-4 tw-py-3"
                        style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                      >
                        <h6>Baths: {{ property.bathroom }}</h6>
                      </div>
                      <div
                        v-if="property.reception"
                        class="tw-px-4 tw-py-3"
                        style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                      >
                        <h6>Reception: {{ property.reception }}</h6>
                      </div>
                    </div>

                    <div v-if="property.description">
                      <h3 class="tw-pb-4">Property Info</h3>
                      <div v-html="property.description"></div>
                    </div>

                    <library-properties-property-criteria-list
                      :property="property"
                      class="tw-mt-8"
                      main-list-title="Amenties"
                    >
                      <template #list-item="{ criteria }">
                        <div style="">
                          <div
                            class="tw-flex tw-items-center tw-gap-4 tw-px-4 tw-py-3"
                            style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                          >
                            <svg
                              width="54"
                              height="54"
                              viewBox="0 0 54 54"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_726_237)">
                                <path
                                  d="M50.5655 25.9352L28.0655 3.43521C27.7845 3.15584 27.4043 2.99902 27.008 2.99902C26.6117 2.99902 26.2316 3.15584 25.9505 3.43521L3.45053 25.9352C3.20479 26.2222 3.07638 26.5913 3.09096 26.9688C3.10554 27.3463 3.26204 27.7044 3.52918 27.9716C3.79633 28.2387 4.15444 28.3952 4.53195 28.4098C4.90946 28.4244 5.27858 28.296 5.56553 28.0502L27.0005 6.61521L48.4355 28.0652C48.7225 28.311 49.0916 28.4394 49.4691 28.4248C49.8466 28.4102 50.2047 28.2537 50.4719 27.9866C50.739 27.7194 50.8955 27.3613 50.9101 26.9838C50.9247 26.6063 50.7963 26.2372 50.5505 25.9502L50.5655 25.9352Z"
                                  fill="var(--c-secondary)"
                                />
                                <path
                                  d="M42 48.0001H34.5V33.0001H19.5V48.0001H12V27.0001L9 30.0001V48.0001C9 48.7958 9.31607 49.5588 9.87868 50.1215C10.4413 50.6841 11.2044 51.0001 12 51.0001H22.5V36.0001H31.5V51.0001H42C42.7957 51.0001 43.5587 50.6841 44.1213 50.1215C44.6839 49.5588 45 48.7958 45 48.0001V29.6401L42 26.6401V48.0001Z"
                                  fill="var(--c-secondary)"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_726_237">
                                  <rect width="54" height="54" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>

                            <div class="tw-flex tw-flex-col">
                              <p>{{ criteria.title }}</p>
                              <h6>{{ criteria.value }}</h6>
                            </div>
                          </div>
                        </div>
                      </template>
                    </library-properties-property-criteria-list>
                  </div>
                </div>

                <div id="video" role="tabpanel" v-show="activeTab.name === 'video'">
                  <div
                    v-if="property?.featured_video"
                    class="tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="
                      background: var(--c-section_secondary);
                      border-radius: var(--rounded);
                      border-color: var(--c-border);
                    "
                  >
                    <h3 class="tw-pb-8">Property Video</h3>
                    <div>
                      <theme2-components-video-popup
                        :component="component"
                        :video-source="property.featured_video?.mediaLink"
                      />
                    </div>
                  </div>
                </div>

                <!-- Virtual Tour -->
                <div id="virtual-tour" role="tabpanel" v-show="activeTab.name === 'virtual-tour'">
                  <div v-if="property.virtual_tour">
                    <nuxt-link
                      v-if="property && property.virtual_tour"
                      :to="property.virtual_tour?.mediaLink"
                      class="n-primary tw-flex tw-max-w-72 tw-items-center tw-justify-center tw-gap-4"
                    >
                      <div>
                        <svg width="36" height="36" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.83398 17.5L8.33398 14.1667M13.334 17.5L11.6673 14.1667L9.16732 11.6667L10.0007 6.66667M10.0007 3.33333C10.0007 3.55435 10.0884 3.76631 10.2447 3.92259C10.401 4.07887 10.613 4.16667 10.834 4.16667C11.055 4.16667 11.267 4.07887 11.4232 3.92259C11.5795 3.76631 11.6673 3.55435 11.6673 3.33333C11.6673 3.11232 11.5795 2.90036 11.4232 2.74408C11.267 2.5878 11.055 2.5 10.834 2.5C10.613 2.5 10.401 2.5878 10.2447 2.74408C10.0884 2.90036 10.0007 3.11232 10.0007 3.33333Z"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M5 9.99996L6.66667 7.49996L10 6.66663L12.5 9.16663L15 9.99996"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      Launch Virtual Tour
                    </nuxt-link>
                  </div>
                </div>

                <!-- FLOOR PLANS -->
                <div id="floor_plan" role="tabpanel" v-show="activeTab.name === 'floor_plan'">
                  <div
                    v-if="property.floor_plans"
                    class="tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="
                      background: var(--c-section_secondary);
                      border-radius: var(--rounded);
                      border-color: var(--c-border);
                    "
                  >
                    <h3>Floor Plans</h3>
                    <floor-plan :data="property.floor_plans" :component="component" class="theme4-floor-plan" />
                  </div>
                </div>

                <!-- MAP -->
                <div id="map" role="tabpanel" v-show="activeTab.name === 'map'">
                  <div
                    class="tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="
                      background: var(--c-section_secondary);
                      border-radius: var(--rounded);
                      border-color: var(--c-border);
                    "
                  >
                    <h3 class="tw-pb-8">Map</h3>
                    <neuron-google-map
                      v-if="property.map_position && property.map_position.lat && property.map_position.lng"
                      v-model:map-center-position="property.map_position"
                      :component="component"
                      :marker-color="markerColor"
                    />
                  </div>
                </div>

                <!-- EPC -->
                <div id="epc" role="tabpanel" v-show="activeTab.name === 'epc'">
                  <div
                    class="tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="
                      background: var(--c-section_secondary);
                      border-radius: var(--rounded);
                      border-color: var(--c-border);
                    "
                  >
                    <h3 class="tw-pb-8">EPC</h3>

                    <epc :data="property.epcs" :component="component" />
                  </div>
                </div>
              </div>
            </div>

            <!-- <library-tools-stamp-duty-calculator
            v-if="isMortgageCalculatorVisible"
            :default-price="property.price.numberPrice"
          />
          <library-tools-mortgage-calculator
            v-if="isStampDutyCalculatorVisible"
            :default-price="property.price.numberPrice"
          /> -->
          </div>
          <!-- Property Video, Send Lead: START -->
          <div class="tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-4">
            <!-- <property-detail-actions
            v-if="!isMobileDevice"
            :property="property"
            :component="component"
            @on-send-lead="onSendLead()"
          /> -->
            <div v-if="sidebarComponents && sidebarComponents.length" class="tw-mt-4">
              <available-components-for-sidebar
                key="property-detail-sidebar"
                key-prefix="property-detail-sidebar"
                :specific-components="sidebarComponents"
              />
            </div>
          </div>
          <!-- Property Video, Send Lead: END -->
        </div>
      </div>

      <full-screen-gallery
        v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
        v-model:active-media-index="activeMediaIndex"
        :component="component"
        :active-media="activeMedia"
        :count-of-medias="property.medias.length"
        @close="closeLightbox()"
      />

      <popup :config="sendLeadPopupConfig" custom-width="800px">
        <template #content>
          <send-lead
            v-if="sendLeadPopupConfig.isActive"
            :property="property"
            @on-success="onSuccess"
            @close="sendLeadPopupConfig.isActive = false"
          />
        </template>
      </popup>
      <popup :config="successModalConfig" @close="onSuccessModalClosed()">
        <template #content>
          <success :text="successPopupText" />
        </template>
      </popup>
    </section>

    <section
      v-else-if="variant === variants.v3 && !property.is_locked"
      class="n-section-primary !tw-pt-0"
      style="background-color: var(--c-section_tertiary)"
    >
      <div class="n-main-container tw-w-full">
        <div class="tw-grid tw-grid-cols-12 md:tw-gap-x-10">
          <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8">
            <div>
              <div class="tab-content tw-mt-4 tw-flex tw-flex-col tw-gap-6">
                <div id="features" role="tabpanel" v-show="activeTab.name === 'features'">
                  <div
                    class="tw-flex tw-flex-col tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="background: #fff; border-radius: var(--rounded); border-color: var(--c-border)"
                  >
                    <h3>Features</h3>
                    <div class="tw-mt-4 tw-grid tw-grid-cols-12 tw-gap-4">
                      <div
                        v-for="(feature, index) in property.features"
                        :key="`property-feature-${index}`"
                        class="tw-col-span-12 tw-flex tw-h-[40px] tw-items-center tw-gap-x-3 md:tw-col-span-6"
                      >
                        <span>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                              fill="#EC5D23"
                            />
                          </svg>
                        </span>
                        <library-text class="tw-text-sm tw-font-semibold tw-uppercase" :text="feature"> </library-text>
                      </div>
                    </div>
                  </div>
                </div>

                <div id="information" role="tabpanel" v-show="activeTab.name === 'information'">
                  <div
                    class="tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="background: #fff; border-radius: var(--rounded); border-color: var(--c-border)"
                  >
                    <div class="tw-flex tw-items-center tw-gap-4 tw-pb-8">
                      <div
                        v-if="property.bedroom"
                        class="tw-px-4 tw-py-3"
                        style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                      >
                        <h6>Beds: {{ property.bedroom }}</h6>
                      </div>
                      <div
                        v-if="property.bathroom"
                        class="tw-px-4 tw-py-3"
                        style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                      >
                        <h6>Baths: {{ property.bathroom }}</h6>
                      </div>
                      <div
                        v-if="property.reception"
                        class="tw-px-4 tw-py-3"
                        style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                      >
                        <h6>Reception: {{ property.reception }}</h6>
                      </div>
                    </div>

                    <div v-if="property.description">
                      <h3 class="tw-pb-4">Property Info</h3>
                      <div v-html="property.description"></div>
                    </div>

                    <library-properties-property-criteria-list
                      :property="property"
                      class="tw-mt-8"
                      main-list-title="Amenties"
                    >
                      <template #list-item="{ criteria }">
                        <div style="">
                          <div
                            class="tw-flex tw-items-center tw-gap-4 tw-px-4 tw-py-3"
                            style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                          >
                            <svg
                              width="54"
                              height="54"
                              viewBox="0 0 54 54"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_726_237)">
                                <path
                                  d="M50.5655 25.9352L28.0655 3.43521C27.7845 3.15584 27.4043 2.99902 27.008 2.99902C26.6117 2.99902 26.2316 3.15584 25.9505 3.43521L3.45053 25.9352C3.20479 26.2222 3.07638 26.5913 3.09096 26.9688C3.10554 27.3463 3.26204 27.7044 3.52918 27.9716C3.79633 28.2387 4.15444 28.3952 4.53195 28.4098C4.90946 28.4244 5.27858 28.296 5.56553 28.0502L27.0005 6.61521L48.4355 28.0652C48.7225 28.311 49.0916 28.4394 49.4691 28.4248C49.8466 28.4102 50.2047 28.2537 50.4719 27.9866C50.739 27.7194 50.8955 27.3613 50.9101 26.9838C50.9247 26.6063 50.7963 26.2372 50.5505 25.9502L50.5655 25.9352Z"
                                  fill="var(--c-secondary)"
                                />
                                <path
                                  d="M42 48.0001H34.5V33.0001H19.5V48.0001H12V27.0001L9 30.0001V48.0001C9 48.7958 9.31607 49.5588 9.87868 50.1215C10.4413 50.6841 11.2044 51.0001 12 51.0001H22.5V36.0001H31.5V51.0001H42C42.7957 51.0001 43.5587 50.6841 44.1213 50.1215C44.6839 49.5588 45 48.7958 45 48.0001V29.6401L42 26.6401V48.0001Z"
                                  fill="var(--c-secondary)"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_726_237">
                                  <rect width="54" height="54" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>

                            <div class="tw-flex tw-flex-col">
                              <p>{{ criteria.title }}</p>
                              <h6>{{ criteria.value }}</h6>
                            </div>
                          </div>
                        </div>
                      </template>
                    </library-properties-property-criteria-list>
                  </div>
                </div>

                <div id="video" role="tabpanel" v-show="activeTab.name === 'video'">
                  <div
                    v-if="property?.featured_video"
                    class="tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="background: #fff; border-radius: var(--rounded); border-color: var(--c-border)"
                  >
                    <h3 class="tw-pb-8">Property Video</h3>
                    <div>
                      <theme2-components-video-popup
                        :component="component"
                        :video-source="property.featured_video?.mediaLink"
                      />
                    </div>
                  </div>
                </div>

                <!-- Virtual Tour -->
                <div id="virtual-tour" role="tabpanel" v-show="activeTab.name === 'virtual-tour'">
                  <div v-if="property.virtual_tour">
                    <nuxt-link
                      v-if="property && property.virtual_tour"
                      :to="property.virtual_tour?.mediaLink"
                      class="n-primary tw-flex tw-max-w-72 tw-items-center tw-justify-center tw-gap-4"
                    >
                      <div>
                        <svg width="36" height="36" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.83398 17.5L8.33398 14.1667M13.334 17.5L11.6673 14.1667L9.16732 11.6667L10.0007 6.66667M10.0007 3.33333C10.0007 3.55435 10.0884 3.76631 10.2447 3.92259C10.401 4.07887 10.613 4.16667 10.834 4.16667C11.055 4.16667 11.267 4.07887 11.4232 3.92259C11.5795 3.76631 11.6673 3.55435 11.6673 3.33333C11.6673 3.11232 11.5795 2.90036 11.4232 2.74408C11.267 2.5878 11.055 2.5 10.834 2.5C10.613 2.5 10.401 2.5878 10.2447 2.74408C10.0884 2.90036 10.0007 3.11232 10.0007 3.33333Z"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M5 9.99996L6.66667 7.49996L10 6.66663L12.5 9.16663L15 9.99996"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      Launch Virtual Tour
                    </nuxt-link>
                  </div>
                </div>

                <!-- FLOOR PLANS -->
                <div id="floor_plan" role="tabpanel" v-show="activeTab.name === 'floor_plan'">
                  <div
                    v-if="property.floor_plans"
                    class="tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="background: #fff; border-radius: var(--rounded); border-color: var(--c-border)"
                  >
                    <h3>Floor Plans</h3>
                    <floor-plan :data="property.floor_plans" :component="component" class="theme4-floor-plan" />
                  </div>
                </div>

                <!-- MAP -->
                <div id="map" role="tabpanel" v-show="activeTab.name === 'map'">
                  <div
                    class="tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="background: #fff; border-radius: var(--rounded); border-color: var(--c-border)"
                  >
                    <h3 class="tw-pb-8">Map</h3>
                    <neuron-google-map
                      v-if="property.map_position && property.map_position.lat && property.map_position.lng"
                      v-model:map-center-position="property.map_position"
                      :component="component"
                      :marker-color="markerColor"
                    />
                  </div>
                </div>

                <!-- EPC -->
                <div id="epc" role="tabpanel" v-show="activeTab.name === 'epc'">
                  <div
                    class="tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="background: #fff; border-radius: var(--rounded); border-color: var(--c-border)"
                  >
                    <h3 class="tw-pb-8">EPC</h3>

                    <epc :data="property.epcs" :component="component" />
                  </div>
                </div>
              </div>
            </div>

            <!-- <library-tools-stamp-duty-calculator
            v-if="isMortgageCalculatorVisible"
            :default-price="property.price.numberPrice"
          />
          <library-tools-mortgage-calculator
            v-if="isStampDutyCalculatorVisible"
            :default-price="property.price.numberPrice"
          /> -->
          </div>
          <!-- Property Video, Send Lead: START -->
          <div class="tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-4">
            <div
              class="tw-hidden tw-bg-white tw-p-4 lg:tw-flex"
              style="border-radius: var(--rounded)"
              v-if="property?.featured_video?.mediaLink"
            >
              <library-iframe
                :src="property.featured_video?.mediaLink"
                :h-ratio="16"
                :w-ratio="9"
                class="tw-w-full"
                style="border-radius: var(--rounded)"
              />
            </div>
            <div v-if="sidebarComponents && sidebarComponents.length" class="tw-mt-4">
              <available-components-for-sidebar
                key="property-detail-sidebar"
                key-prefix="property-detail-sidebar"
                :specific-components="sidebarComponents"
              />
            </div>
          </div>
          <!-- Property Video, Send Lead: END -->
        </div>
      </div>

      <full-screen-gallery
        v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
        v-model:active-media-index="activeMediaIndex"
        :component="component"
        :active-media="activeMedia"
        :count-of-medias="property.medias.length"
        @close="closeLightbox()"
      />

      <popup :config="sendLeadPopupConfig" custom-width="800px">
        <template #content>
          <send-lead
            v-if="sendLeadPopupConfig.isActive"
            :property="property"
            @on-success="onSuccess"
            @close="sendLeadPopupConfig.isActive = false"
          />
        </template>
      </popup>
      <popup :config="successModalConfig" @close="onSuccessModalClosed()">
        <template #content>
          <success :text="successPopupText" />
        </template>
      </popup>
    </section>


     <section
      v-else-if="variant === variants.v4 && !property.is_locked"
      class="n-section-primary !tw-pt-0"
      style="background-color: var(--c-section_tertiary)"
    >
      <div class="n-main-container tw-w-full">
        <div class="tw-grid tw-grid-cols-12 md:tw-gap-x-10">
          <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8">
            <div>
              <div class="tab-content tw-mt-4 tw-flex tw-flex-col tw-gap-6">
                <div id="features" role="tabpanel" v-show="activeTab.name === 'features'">
                  <div
                    class="tw-flex tw-flex-col tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="background: #fff; border-radius: var(--rounded); border-color: var(--c-border)"
                  >
                    <h3>Features</h3>
                    <div class="tw-mt-4 tw-grid tw-grid-cols-12 tw-gap-4">
                      <div
                        v-for="(feature, index) in property.features"
                        :key="`property-feature-${index}`"
                        class="tw-col-span-12 tw-flex tw-h-[40px] tw-items-center tw-gap-x-3 md:tw-col-span-6"
                      >
                        <span>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                              fill="var(--c-primary)"
                            />
                          </svg>
                        </span>
                        <library-text class="tw-text-sm tw-font-semibold tw-uppercase" :text="feature"> </library-text>
                      </div>
                    </div>
                  </div>
                </div>

                <div id="information" role="tabpanel" v-show="activeTab.name === 'information'">
                  <div
                    class="tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="background: #fff; border-radius: var(--rounded); border-color: var(--c-border)"
                  >
                    <div class="tw-flex tw-items-center tw-gap-4 tw-pb-8">
                      <div
                        v-if="property.bedroom"
                        class="tw-px-4 tw-py-3"
                        style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                      >
                        <h6>Beds: {{ property.bedroom }}</h6>
                      </div>
                      <div
                        v-if="property.bathroom"
                        class="tw-px-4 tw-py-3"
                        style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                      >
                        <h6>Baths: {{ property.bathroom }}</h6>
                      </div>
                      <div
                        v-if="property.reception"
                        class="tw-px-4 tw-py-3"
                        style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                      >
                        <h6>Reception: {{ property.reception }}</h6>
                      </div>
                    </div>

                    <div v-if="property.description">
                      <h3 class="tw-pb-4">Property Info</h3>
                      <div v-html="property.description"></div>
                    </div>

                    <library-properties-property-criteria-list
                      :property="property"
                      class="tw-mt-8"
                      main-list-title="Amenties"
                    >
                      <template #list-item="{ criteria }">
                        <div style="">
                          <div
                            class="tw-flex tw-items-center tw-gap-4 tw-px-4 tw-py-3"
                            style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                          >
                            <svg
                              width="54"
                              height="54"
                              viewBox="0 0 54 54"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_726_237)">
                                <path
                                  d="M50.5655 25.9352L28.0655 3.43521C27.7845 3.15584 27.4043 2.99902 27.008 2.99902C26.6117 2.99902 26.2316 3.15584 25.9505 3.43521L3.45053 25.9352C3.20479 26.2222 3.07638 26.5913 3.09096 26.9688C3.10554 27.3463 3.26204 27.7044 3.52918 27.9716C3.79633 28.2387 4.15444 28.3952 4.53195 28.4098C4.90946 28.4244 5.27858 28.296 5.56553 28.0502L27.0005 6.61521L48.4355 28.0652C48.7225 28.311 49.0916 28.4394 49.4691 28.4248C49.8466 28.4102 50.2047 28.2537 50.4719 27.9866C50.739 27.7194 50.8955 27.3613 50.9101 26.9838C50.9247 26.6063 50.7963 26.2372 50.5505 25.9502L50.5655 25.9352Z"
                                  fill="var(--c-secondary)"
                                />
                                <path
                                  d="M42 48.0001H34.5V33.0001H19.5V48.0001H12V27.0001L9 30.0001V48.0001C9 48.7958 9.31607 49.5588 9.87868 50.1215C10.4413 50.6841 11.2044 51.0001 12 51.0001H22.5V36.0001H31.5V51.0001H42C42.7957 51.0001 43.5587 50.6841 44.1213 50.1215C44.6839 49.5588 45 48.7958 45 48.0001V29.6401L42 26.6401V48.0001Z"
                                  fill="var(--c-secondary)"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_726_237">
                                  <rect width="54" height="54" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>

                            <div class="tw-flex tw-flex-col">
                              <p>{{ criteria.title }}</p>
                              <h6>{{ criteria.value }}</h6>
                            </div>
                          </div>
                        </div>
                      </template>
                    </library-properties-property-criteria-list>
                  </div>
                </div>

                <div id="video" role="tabpanel" v-show="activeTab.name === 'video'">
                  <div
                    v-if="property?.featured_video"
                    class="tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="background: #fff; border-radius: var(--rounded); border-color: var(--c-border)"
                  >
                    <h3 class="tw-pb-8">Property Video</h3>
                    <div>
                      <theme2-components-video-popup
                        :component="component"
                        :video-source="property.featured_video?.mediaLink"
                      />
                    </div>
                  </div>
                </div>

                <!-- Virtual Tour -->
                <div id="virtual-tour" role="tabpanel" v-show="activeTab.name === 'virtual-tour'">
                  <div v-if="property.virtual_tour">
                    <nuxt-link
                      v-if="property && property.virtual_tour"
                      :to="property.virtual_tour?.mediaLink"
                      class="n-primary tw-flex tw-max-w-72 tw-items-center tw-justify-center tw-gap-4"
                    >
                      <div>
                        <svg width="36" height="36" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.83398 17.5L8.33398 14.1667M13.334 17.5L11.6673 14.1667L9.16732 11.6667L10.0007 6.66667M10.0007 3.33333C10.0007 3.55435 10.0884 3.76631 10.2447 3.92259C10.401 4.07887 10.613 4.16667 10.834 4.16667C11.055 4.16667 11.267 4.07887 11.4232 3.92259C11.5795 3.76631 11.6673 3.55435 11.6673 3.33333C11.6673 3.11232 11.5795 2.90036 11.4232 2.74408C11.267 2.5878 11.055 2.5 10.834 2.5C10.613 2.5 10.401 2.5878 10.2447 2.74408C10.0884 2.90036 10.0007 3.11232 10.0007 3.33333Z"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M5 9.99996L6.66667 7.49996L10 6.66663L12.5 9.16663L15 9.99996"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      Launch Virtual Tour
                    </nuxt-link>
                  </div>
                </div>

                <!-- FLOOR PLANS -->
                <div id="floor_plan" role="tabpanel" v-show="activeTab.name === 'floor_plan'">
                  <div
                    v-if="property.floor_plans"
                    class="tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="background: #fff; border-radius: var(--rounded); border-color: var(--c-border)"
                  >
                    <h3>Floor Plans</h3>
                    <floor-plan :data="property.floor_plans" :component="component" class="theme4-floor-plan" />
                  </div>
                </div>

                <!-- MAP -->
                <div id="map" role="tabpanel" v-show="activeTab.name === 'map'">
                  <div
                    class="tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="background: #fff; border-radius: var(--rounded); border-color: var(--c-border)"
                  >
                    <h3 class="tw-pb-8">Map</h3>
                    <neuron-google-map
                      v-if="property.map_position && property.map_position.lat && property.map_position.lng"
                      v-model:map-center-position="property.map_position"
                      :component="component"
                      :marker-color="markerColor"
                    />
                  </div>
                </div>

                <!-- EPC -->
                <div id="epc" role="tabpanel" v-show="activeTab.name === 'epc'">
                  <div
                    class="tw-rounded tw-border tw-p-6 lg:tw-p-10"
                    style="background: #fff; border-radius: var(--rounded); border-color: var(--c-border)"
                  >
                    <h3 class="tw-pb-8">EPC</h3>

                    <epc :data="property.epcs" :component="component" />
                  </div>
                </div>
              </div>
            </div>

            <!-- <library-tools-stamp-duty-calculator
            v-if="isMortgageCalculatorVisible"
            :default-price="property.price.numberPrice"
          />
          <library-tools-mortgage-calculator
            v-if="isStampDutyCalculatorVisible"
            :default-price="property.price.numberPrice"
          /> -->
          </div>
          <!-- Property Video, Send Lead: START -->
          <div class="tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-4">
            <div
              class="tw-hidden tw-bg-white tw-p-4 lg:tw-flex"
              style="border-radius: var(--rounded)"
              v-if="property?.featured_video?.mediaLink"
            >
              <library-iframe
                :src="property.featured_video?.mediaLink"
                :h-ratio="16"
                :w-ratio="9"
                class="tw-w-full"
                style="border-radius: var(--rounded)"
              />
            </div>
            <div v-if="sidebarComponents && sidebarComponents.length" class="tw-mt-4">
              <available-components-for-sidebar
                key="property-detail-sidebar"
                key-prefix="property-detail-sidebar"
                :specific-components="sidebarComponents"
              />
            </div>
          </div>
          <!-- Property Video, Send Lead: END -->
        </div>
      </div>

      <full-screen-gallery
        v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
        v-model:active-media-index="activeMediaIndex"
        :component="component"
        :active-media="activeMedia"
        :count-of-medias="property.medias.length"
        @close="closeLightbox()"
      />

      <popup :config="sendLeadPopupConfig" custom-width="800px">
        <template #content>
          <send-lead
            v-if="sendLeadPopupConfig.isActive"
            :property="property"
            @on-success="onSuccess"
            @close="sendLeadPopupConfig.isActive = false"
          />
        </template>
      </popup>
      <popup :config="successModalConfig" @close="onSuccessModalClosed()">
        <template #content>
          <success :text="successPopupText" />
        </template>
      </popup>
    </section>


    <section
      v-else-if="!property?.is_locked && variant === variants.v2"
      class="n-section-secondary"
      :style="`background-color: var(--c-${vars.detailBackgroundColor})`"
    >
      <div class="tw-w-full tw-grid-cols-12 tw-gap-10 max-lg:tw-flex max-lg:tw-flex-col lg:tw-grid">
        <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-8 lg:tw-col-span-7 xl:tw-col-span-8">
          <div v-if="property?.featured_video?.mediaLink" class="property-detail-card tw-mb-6 tw-block lg:tw-hidden">
            <div class="tw-relative">
              <div class="tw-aspect-[9/16] tw-h-full tw-w-full">
                <iframe
                  class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
                  :src="property.featured_video.mediaLink"
                  style="border-radius: var(--rounded)"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>

          <div v-if="property.floor_plans.length" class="property-detail-card">
            <h3>Floor Plans</h3>
            <floor-plan :data="property.floor_plans" :component="component" class="theme4-floor-plan" />
          </div>
          <!-- Property Info -->
          <div v-if="property.description" class="property-detail-card accordion">
            <library-content-accordion
              :collapsed="true"
              :elements="[
                {
                  title: 'Property Info',
                  description: property.description,
                },
              ]"
              :active-index="-1"
            />
          </div>

          <!-- Property Features -->
          <div v-if="property.features" class="property-detail-card accordion">
            <library-content-accordion
              :collapsed="true"
              :elements="[
                {
                  title: 'Features',
                },
              ]"
            >
              <template #description>
                <div class="tw-grid tw-grid-cols-12 tw-gap-4">
                  <div
                    v-for="(feature, index) in property.features"
                    :key="`property-feature-${index}`"
                    class="tw-col-span-12 tw-flex tw-h-[40px] tw-items-center tw-gap-x-3 md:tw-col-span-6"
                  >
                    <span>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                          fill="var(--c-secondary)"
                        />
                      </svg>
                    </span>
                    <library-text class="tw-text-sm tw-font-semibold tw-uppercase" :text="feature"> </library-text>
                  </div>
                </div>
              </template>
            </library-content-accordion>
          </div>

          <!-- Map -->
          <div
            v-if="property.map_position && property.map_position.lat && property.map_position.lng"
            class="property-detail-card accordion"
          >
            <library-content-accordion :collapsed="true" :elements="[{ title: 'Map' }]">
              <template #description>
                <neuron-google-map
                  v-model:map-center-position="property.map_position"
                  :component="component"
                  :marker-color="markerColor"
                />
              </template>
            </library-content-accordion>
          </div>

          <div v-if="property.criteria_list" class="property-detail-card accordion">
            <library-content-accordion
              :collapsed="true"
              :elements="[
                {
                  title: 'Details',
                },
              ]"
            >
              <template #description>
                <div class="pt-4">
                  <library-properties-property-criteria-list :property="property" :main-list-title="null">
                    <template #list-item="{ criteria }">
                      <div style="">
                        <div
                          class="tw-flex tw-items-center tw-gap-4 tw-px-4 tw-py-3"
                          style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                        >
                          <svg
                            width="54"
                            height="54"
                            viewBox="0 0 54 54"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_726_237)">
                              <path
                                d="M50.5655 25.9352L28.0655 3.43521C27.7845 3.15584 27.4043 2.99902 27.008 2.99902C26.6117 2.99902 26.2316 3.15584 25.9505 3.43521L3.45053 25.9352C3.20479 26.2222 3.07638 26.5913 3.09096 26.9688C3.10554 27.3463 3.26204 27.7044 3.52918 27.9716C3.79633 28.2387 4.15444 28.3952 4.53195 28.4098C4.90946 28.4244 5.27858 28.296 5.56553 28.0502L27.0005 6.61521L48.4355 28.0652C48.7225 28.311 49.0916 28.4394 49.4691 28.4248C49.8466 28.4102 50.2047 28.2537 50.4719 27.9866C50.739 27.7194 50.8955 27.3613 50.9101 26.9838C50.9247 26.6063 50.7963 26.2372 50.5505 25.9502L50.5655 25.9352Z"
                                fill="var(--c-secondary)"
                              />
                              <path
                                d="M42 48.0001H34.5V33.0001H19.5V48.0001H12V27.0001L9 30.0001V48.0001C9 48.7958 9.31607 49.5588 9.87868 50.1215C10.4413 50.6841 11.2044 51.0001 12 51.0001H22.5V36.0001H31.5V51.0001H42C42.7957 51.0001 43.5587 50.6841 44.1213 50.1215C44.6839 49.5588 45 48.7958 45 48.0001V29.6401L42 26.6401V48.0001Z"
                                fill="var(--c-secondary)"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_726_237">
                                <rect width="54" height="54" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>

                          <div class="tw-flex tw-flex-col">
                            <p>{{ criteria.title }}</p>
                            <h6>{{ criteria.value }}</h6>
                          </div>
                        </div>
                      </div>
                    </template>
                  </library-properties-property-criteria-list>
                </div>
              </template>
            </library-content-accordion>
          </div>

          <div v-if="property.epcs.length > 0" class="property-detail-card accordion">
            <library-content-accordion :collapsed="true" :elements="[{ title: 'EPC' }]">
              <template #description>
                <epc :data="property.epcs" :component="component" />
              </template>
            </library-content-accordion>
          </div>

          <div v-if="isStampDutyCalculatorVisible" class="property-detail-card accordion">
            <library-content-accordion :collapsed="true" :elements="[{ title: 'Stamp Duty Calculator' }]">
              <template #description>
                <library-tools-stamp-duty-calculator
                  class="accordion-stamp-duty-calculator"
                  :default-price="property.price.numberPrice"
                />
              </template>
            </library-content-accordion>
          </div>

          <div v-if="isMortgageCalculatorVisible" class="property-detail-card accordion">
            <library-content-accordion :collapsed="true" :elements="[{ title: 'Mortgage Calculator' }]">
              <template #description>
                <library-tools-mortgage-calculator
                  class="accordion-mortgage-calculator"
                  :default-price="property.price.numberPrice"
                />
              </template>
            </library-content-accordion>
          </div>
        </div>
        <!-- sidebar -->
        <div class="tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-4">
          <div v-if="sidebarComponents && sidebarComponents.length">
            <div v-if="property.featured_video?.mediaLink" class="property-detail-card tw-mb-6 tw-hidden lg:tw-block">
              <div class="tw-relative">
                <div class="tw-aspect-[9/16] tw-h-full tw-w-full">
                  <iframe
                    class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
                    :src="property.featured_video?.mediaLink"
                    style="border-radius: var(--rounded)"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
            <div class="tw-flex tw-flex-col tw-gap-4">
              <available-components-for-sidebar
                key="property-detail-sidebar"
                key-prefix="property-detail-sidebar"
                :specific-components="sidebarComponents"
              />
            </div>
          </div>
        </div>
      </div>

      <full-screen-gallery
        v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
        v-model:active-media-index="activeMediaIndex"
        :component="component"
        :active-media="activeMedia"
        :count-of-medias="property.medias.length"
        :portrait-video="true"
        @close="closeLightbox()"
      />

      <popup :config="sendLeadPopupConfig" custom-width="800px">
        <template #content>
          <send-lead
            v-if="sendLeadPopupConfig.isActive"
            :property="property"
            @on-success="onSuccess"
            @close="sendLeadPopupConfig.isActive = false"
          />
        </template>
      </popup>
      <popup :config="successModalConfig" @close="onSuccessModalClosed()">
        <template #content>
          <success :text="successPopupText" />
        </template>
      </popup>
    </section>
    <section
      v-if="property?.is_locked"
      style="background-color: var(--c-tertiary)"
      class="tw-my-14 tw-grid tw-grid-cols-12"
    >
      <div class="tw-col-span-12 lg:tw-col-span-7">
        <library-login />
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { mapActions } from 'pinia';
import { ROUTES } from '~/constants/ui.constants';
import { usePropertiesStore } from '~/units/properties/stores';
import type { Component } from '~/types';
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertyMixin } from '~/units/properties/mixins/property.mixin';
import FloorPlan from '~/components/common/FloorPlan.vue';
import NeuronGoogleMap from '~/components/common/NeuronGoogleMap.vue';
import Epc from '~/components/common/Epc.vue';
import NcSelect from '~/components/common/inputs/NcSelect.vue';
import NcInput from '~/components/common/inputs/NcInput.vue';
import NcButton from '~/components/common/inputs/NcButton.vue';
import FullScreenGallery from '~/components/common/FullScreenGallery.vue';
import { useCoreStore } from '~/units/core/store';
import SendLead from '~/components/common/leads/SendLead.vue';
import Success from '~/components/common/popup/Success.vue';
import Popup from '~/components/common/popup/Popup.vue';
import PropertyDetailActions from '~/components/theme4/properties/PropertyDetailActions.vue';
import AvailableComponentsForSidebar from '~/components/theme4/AvailableComponentsForSidebar.vue';
import { FullScreenPopupMixin } from '~/units/core/mixins/fullScreenPopupMixin';
import { getImagesByCount } from '~/units/properties/store';

export default defineNuxtComponent({
  name: 'Theme4PropertyDetail',
  components: {
    AvailableComponentsForSidebar,
    PropertyDetailActions,
    Popup,
    Success,
    SendLead,
    FullScreenGallery,
    NcButton,
    NcInput,
    NcSelect,
    Epc,
    NeuronGoogleMap,
    FloorPlan,
  },

  mixins: [ComponentMixin, PropertyMixin, FullScreenPopupMixin],

  data() {
    return {
      activeTab: { name: 'features', title: 'Features' },
      swiper: {},
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        v4: 'v4',
      },
    };
  },

  computed: {
    tabs() {
      const tabs = [
        { name: 'features', title: 'Features', is_visible: true },
        { name: 'information', title: 'Property Info', is_visible: true },
        { name: 'video', title: 'Property Video', is_visible: !!this.property?.featured_video },
        { name: 'virtual-tour', title: 'Virtual Tour', is_visible: !!this.property?.virtual_tour },
        { name: 'floor_plan', title: 'Floor Plans', is_visible: !!this.property?.floor_plans?.length },
        { name: 'map', title: 'Map', is_visible: true },
        { name: 'epc', title: 'EPC', is_visible: !!this.property?.epcs?.length },
      ];
      return tabs.filter((i) => i.is_visible);
    },

    markerColor() {
      return this.colors.primary;
    },

    ROUTES() {
      return ROUTES;
    },

    primaryFivePhotos() {
      if (this.property) {
        return getImagesByCount(this.property, 5);
      }
      return [];
    },

    primarySevenPhotos() {
      if (this.property) {
        return getImagesByCount(this.property, 7);
      }
      return [];
    },

    // ✅ Mobilde tüm fotoğraflar için
 allPhotos() {
  const medias = this.property?.medias ?? [];
  const fv = this.property?.featured_video || {};

  const videoThumbUrls = new Set(
    [fv?.background, fv?.coverPhoto, fv?.thumbnail, fv?.thumb, fv?.image]
      .filter(Boolean)
  );

  return medias
    .filter((m) => {
      // 1) Video tiplerini at
      const isVideo =
        m?.type === 'video' ||
        m?.mediaType === 'video' ||
        m?.kind === 'video' ||
        m?.isVideo === true;

      if (isVideo) return false;

      // 2) Foto değilse at
      const hasImageUrl = m?.background || m?.url || m?.src;
      if (!hasImageUrl) return false;

      // 3) Video kapağı/thumbnail’i ile aynıysa at
      const bg = m.background || m.url || m.src;
      if (bg && videoThumbUrls.has(bg)) return false;

      // 4) Aynı id/link referansı varsa at (bazı backend’ler video ve thumb için aynı id’yi döndürebiliyor)
      if (
        (fv?.id && (m?.id === fv.id || m?.mediaId === fv.id)) ||
        (fv?.mediaId && (m?.id === fv.mediaId || m?.mediaId === fv.mediaId)) ||
        (fv?.mediaLink && (m?.mediaLink === fv.mediaLink))
      ) {
        return false;
      }

      return true;
    })
    .map((m, i) => ({
      ...m,
      background: m.background || m.url || m.src,
      __key: m.id || m.mediaId || `photo-${i}`,
    }));
},

    sidebarComponents(): Component[] {
      if (this.currentPage && this.currentPage.sidebar) {
        return this.currentPage.sidebar;
      }
      return [];
    },

    isMortgageCalculatorVisible() {
      return !this.vars.isMortgageCalculatorHiddenNumber;
    },

    isStampDutyCalculatorVisible() {
      return !this.vars.isStampDutyCalculatorHiddenNumber;
    },

    isLetterPropertyCriteria() {
      return this.vars.isLetterPropertyCriteriaNumber;
    },
  },

  methods: {
    ...mapActions(useCoreStore, ['shareApi', 'openTab']),

    async onShared() {
      await this.shareApi({
        title: this.property?.advert_heading,
        text: this.property?.advert_heading,
        url: window.location.href,
      });
    },

    onSwiper(swiper: object) {
      this.swiper = swiper;
    },
  },

  async setup(props: { component: Component }) {
    const store = usePropertiesStore();
    await store.fetchSingleProperty(props.component);
  },
});
</script>

<style scoped>
.share-button {
  border: 2px solid var(--camel);
}

.nav-link.active {
  color: var(--purple);
  border-bottom-color: var(--purple);
}

.nav-link {
  color: var(--black);
  font-size: 16px;
}

.image-container {
  position: relative;
}

.image-container img {
  display: block;
}

.nc-first-image-overlay-item {
  position: absolute;
  bottom: 0.1rem;
  right: 0.1rem;
  transform: translate(-50%, -50%);
  text-align: right;
  background-color: var(--white);
  padding: 5px 10px 5px 10px;
  color: var(--nc-classic-black);
  border-radius: 4px;
}

.nc-all-photos-button {
  position: absolute;
  bottom: 20px;
  left: 70px;
  padding: 10px;
  border-radius: 4px;
  background-color: var(--white);
  color: var(--nc-classic-black);
}

.photo-next,
.photo-prev {
  position: absolute;
  top: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 44px;
  height: 64px;
  background-color: #fff;
  border-radius: var(--rounded);
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  font-size: 26px;
}

.photo-next {
  right: 5%;
}

.photo-prev {
  left: 5%;
}

::v-deep(.floor-tab .floor-plan-items .floor-plan-card) {
  width: 100% !important;
}

::v-deep(.floor-tab .floor-plan-items .floor-plan-card figure) {
  border: none !important;
}

::v-deep(.floor-tab) {
  padding: unset !important;
}

::v-deep(.inline-iframe-container iframe) {
  height: 590px;
}

.theme4-floor-plan ::v-deep(figure) {
  height: unset !important;
}

.swiper-button-next::after,
.swiper-button-prev::after {
  content: unset;
}
.swiper-button-next,
.swiper-button-prev {
  width: unset;
  height: unset;
}

::v-deep(img) {
  border-radius: 4px;
}

.property-detail-card {
  padding: 24px;
  border-radius: var(--rounded);
  background-color: var(--c-section_primary);
}

.property-detail-card.accordion {
  padding-bottom: 0;
  padding-top: 0;
}

@media screen and (min-width: 1024px) {
  .property-detail-card {
    padding: 32px;
  }

  .property-detail-card.accordion {
    padding-bottom: 0;
    padding-top: 0;
  }
}

.accordion-stamp-duty-calculator ::v-deep(h3),
.accordion-mortgage-calculator ::v-deep(h3) {
  display: none;
}

.accordion-stamp-duty-calculator ::v-deep(.stamp-duty-result),
.accordion-mortgage-calculator ::v-deep(.mortgage-result) {
  background: var(--c-primary);
  border-radius: var(--rounded);
}
.accordion-stamp-duty-calculator ::v-deep(select),
.accordion-stamp-duty-calculator ::v-deep(.n-input),
.accordion-stamp-duty-calculator ::v-deep(input),
.accordion-mortgage-calculator ::v-deep(select),
.accordion-mortgage-calculator ::v-deep(.n-input),
.accordion-mortgage-calculator ::v-deep(input) {
  background: var(--c-input_secondary) !important;
}

/* Sadece v3 mobil görünüm için ince ayar */
@media (max-width: 1023px) {
  .v3-tabs .nav-item {
    justify-self: center; /* grid içinde ortala */
  }

  .v3-tabs .nav-link.active {
    color: var(--c-primary) !important; /* aktif sekme rengi */
  }
}
</style>
